<template>
  <div
    class="agenda-page-wrap"
    style="padding: 0; margin-top: 64px"
    :class="{ landscape: orientation, portrait: !orientation }"
    v-if="!noData"
  >
    <a-row
      type="flex"
      justify="center"
      style="max-width: 1220px; width: 100%"
      class="heading-wrap"
    >
      <a-col :span="24" :lg="12">
        <h1 class="page-title"> {{ fairConfig.FC_AGENDA_NAME }}</h1>
        <!-- <h1 class="page-title">{{ $t("agenda.agenda") }}</h1> -->
      </a-col>
      <a-col :span="12" :lg="0">
        <a-button class="mobile-filters" @click="showFiltersDrawer"
          >{{$t('agendaNew.filters')}}<a-icon type="filter" />
        </a-button>
      </a-col>
      <a-drawer
        :title="$t('agendaNew.filters')"
        placement="left"
        class="filtersDrawer"
        :visible="filtersDrawerVisible"
        :closable="true"
        @close="onCloseFiltersDrawer"
        width="80%"
      >
        <!--  <h1
          class="mobile-drawer-title"
          style="font-size:18px;line-height:20px;font-weight:500"
        >
          Filters <a-icon type="filter" />
        </h1> -->
        <h1 class="filter-title" style="font-size:16px;line-height:22px">
          {{$t('agendaNew.days')}}
        </h1>
        <a-radio-group
          v-model="selectedDay"
          :options="dayCheckBoxOptions"
          :default-value="$t('agendaNew.allDays')"
          @change="handleAnyFilterChange"
        />
        <h1 class="filter-title" style="font-size:16px;line-height:22px">
          {{$t('agendaNew.locations')}}
        </h1>
        <a-radio-group
          v-model="selectedLocation"
          :options="locationCheckBoxOptions"
          :default-value="[$t('agendaNew.allLocations')]"
          @change="handleAnyFilterChange"
        />
        <h1 class="filter-title" style="font-size:16px;line-height:22px">
          {{$t('agendaNew.exhibitors')}}
        </h1>
        <a-radio-group
          v-model="selectedExhibitor"
          :options="exhibitorCheckBoxOptions"
          :default-value="[$t('agendaNew.allSpeakers')]"
          @change="handleAnyFilterChange"
        />
        <h1 class="filter-title" style="font-size:16px;line-height:22px">
          {{$t('agendaNew.tags')}}
        </h1>
        <a-checkbox-group
          v-model="selectedTag"
          :options="allTags"
          :default-value="[$t('agendaNew.allTags')]"
          @change="handleAnyFilterChange"
        />
        <div class="drawerButtons" v-if="filtersDrawerVisible">
          <a-button
            type="primary"
            class="applyFiltersBtn"
            @click="onCloseFiltersDrawer"
            >{{$t('agendaNew.applyFilters')}}</a-button
          >
          <a-button
            type="primary"
            class="resetFiltersBtn"
            icon="undo"
            @click="resetFilters"
          />
        </div>
      </a-drawer>
      <a-col :span="12" :lg="0">
        <a-button class="download-btn" :href="agendaDownload"
          >{{$t('agendaNew.downloadPDF')}} <a-icon type="download" />
        </a-button>
      </a-col>
      <a-col :span="0" :lg="12">
        <a-input-search
          v-model="searchText"
          class="search-btn"
          :placeholder="$t('agendaNew.search')"
          @change="searchAgendas"
        />
        <a-button class="download-btn" :href="agendaDownload"
          >{{$t('agendaNew.downloadPDF')}} <a-icon type="download" />
        </a-button>
      </a-col>
    </a-row>

    <a-row
      type="flex"
      justify="center"
      style="max-width: 1220px; margin: 0 auto; width: 100%;"
      class="filter-row"
    >
      <a-col :span="12">
        <a-select
          v-model="selectedDay"
          class="white-dropdown"
          style="width: 130px"
          @change="handleAnyFilterChange"
        >
          <a-select-option :value="$t('agendaNew.allDays')">
            {{$t('agendaNew.allDays')}}</a-select-option>
          <a-select-option v-for="d in uniqueDays" :key="d.date">
            {{ d.dateString }}
          </a-select-option>
        </a-select>

        <a-select
          v-model="selectedLocation"
          class="white-dropdown"
          style="width: 140px"
          @change="handleAnyFilterChange"
        >
          <a-select-option :value="$t('agendaNew.allLocations')">
            {{$t('agendaNew.allLocations')}}
          </a-select-option>
          <a-select-option v-for="d in uniqueLocations" :key="d.loc_id">
            {{ d.loc_name }}
          </a-select-option>
        </a-select>

        <a-select
          v-model="selectedExhibitor"
          class="white-dropdown"
          style="width: 130px"
          @change="handleAnyFilterChange"
        >
          <a-select-option :value="$t('agendaNew.allSpeakers')">
            {{$t('agendaNew.allSpeakers')}}
          </a-select-option>
          <a-select-option v-for="d in uniqueExhibitors" :key="d.speaker_id">
            {{ d.usr_firstname }} {{ d.usr_lastname }}
          </a-select-option>
        </a-select>

        <a-button class="primary"
          style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
          v-on:click="resetFilters">
          {{$t('agendaNew.resetFilters')}}
          </a-button>
      </a-col>
      <a-col :span="12">
        <!-- <a-select
          :default-value="$t('agendaNew.selectTimezone')"
          class="gray-dropdown"
          style="width: 200px; float: right"
          v-model="selectedTimeZone"
          disabled
        >
          <a-select-option
            v-for="time in timezones"
            :key="time.timezone"
            :value="time.value"
          >
            {{ time.timezone }}
          </a-select-option>
        </a-select> -->
      </a-col>
    </a-row>
    <a-row
      class="filters-wrapper"
      type="flex"
      justify="center"
      style="max-width: 1220px; margin: 0 auto; width: 100%;margin-top: -20px;"
    >
      <div class="filter-wrap">
        <p class="filter-headline">{{$t('agendaNew.filterByTag')}}</p>
        <a-select
          v-model="selectedTag"
          :placeholder="$t('agendaNew.selectTag')"
          class="filter-btn"
          mode="multiple"
          @change="handleAnyFilterChange"
          dropdownMatchSelectWidth
        >
          <a-select-option v-for="tag in allTags" :key="tag">
            {{ tag }}
          </a-select-option>
        </a-select>
        <a-button class="filter-btn-no" @click="filterBtnNoClick">
          {{ noOfAdditionalFilters }}
        </a-button>
      </div>
    </a-row>

    <a-row type="flex" justify="center" style="width: 100%" class="this-one">
      <a-col style="max-width: 1220px; margin: 0 auto; width: 100%">
        <a-tabs
        v-model="selectedTab"
          style="padding-bottom: 10px"
          @tabClick="selectTab"
        >
          <a-tab-pane key="1" :tab="$t('agendaNew.eventAgenda')">
            <a-col
              id="main-card-wrap"
              :span="24"
              :lg="previewClosed ? 24 : 12"
              :style="
                previewClosed ? 'padding:24px 0' : 'padding:16px 30px 0 0'
              "
            >
              <!-- Demo events -->
              <!-- <div v-if="demoEventsVisible">
                <h3 class="agenda-day">Saturday, July 10, 2021</h3>

                <a-card
                  :bordered="false"
                  class="gray-card passed"
                  @click="selectEvent"
                >
                  <a-card-grid class="card-time" :hoverable="false">
                    <div class="white-box">
                      <p class="time-from">09:00<sub>AM</sub></p>
                      <p class="time-to">until 10:30<sub>AM</sub></p>
                      <span class="live-event">LIVE</span>
                    </div>
                  </a-card-grid>
                  <a-card-grid :hoverable="false" class="card-description">
                    <a href="#" class="card-agenda"
                      >Added to my agenda
                      <a-icon
                        class="agenda-star active"
                        type="star"
                        theme="filled"
                        style="color: #f7bb58"
                      />
                    </a>
                    <div class="card-content-container">
                      <p class="card-title">Session Title 0</p>
                      <div class="card-buttons">
                        <a href="#" class="card-button">Tag filter 2</a>
                        <a href="#" class="card-button lang"
                          ><a-icon type="flag" style="font-size: 12px" />
                          English</a
                        >
                      </div>
                    </div>
                  </a-card-grid>
                </a-card>

                <a-card
                  :bordered="false"
                  class="purple-card live active"
                  @click="selectEvent"
                >
                  <a-card-grid class="card-time" :hoverable="false">
                    <div class="white-box">
                      <p class="time-from">11:00<sub>AM</sub></p>
                      <p class="time-to">until 11:30<sub>AM</sub></p>
                      <span class="live-event">LIVE</span>
                    </div>
                  </a-card-grid>
                  <a-card-grid :hoverable="false" class="card-description">
                    <a href="#" class="card-agenda"
                      >Added to my agenda
                      <a-icon
                        class="agenda-star active"
                        type="star"
                        theme="filled"
                        style="color: #f7bb58"
                      />
                    </a>
                    <div class="card-content-container">
                      <p class="card-title">Session Title 1</p>
                      <div class="card-buttons">
                        <a href="#" class="card-button">Tag filter 1</a>
                        <a href="#" class="card-button lang"
                          ><a-icon type="flag" style="font-size: 12px" />
                          English</a
                        >
                        <a href="#" class="card-button join">Join session</a>
                      </div>
                    </div>
                  </a-card-grid>
                </a-card>

                <a-card
                  :bordered="false"
                  class="green-card live"
                  @click="selectEvent"
                >
                  <a-card-grid class="card-time" :hoverable="false">
                    <div class="white-box">
                      <p class="time-from">11:00<sub>AM</sub></p>
                      <p class="time-to">until 12:30<sub>PM</sub></p>
                      <span class="live-event">LIVE</span>
                    </div>
                  </a-card-grid>
                  <a-card-grid :hoverable="false" class="card-description">
                    <a href="#" class="card-agenda"
                      >Added to my agenda
                      <a-icon
                        class="agenda-star active"
                        type="star"
                        theme="filled"
                        style="color: #f7bb58"
                      />
                    </a>
                    <div class="card-content-container">
                      <p class="card-title">Session Title 2</p>
                      <div class="card-buttons">
                        <a href="#" class="card-button">Tag filter 2</a>
                        <a href="#" class="card-button lang"
                          ><a-icon type="flag" style="font-size: 12px" />
                          English</a
                        >
                        <a href="#" class="card-button join">Join session</a>
                      </div>
                    </div>
                  </a-card-grid>
                </a-card>

                <a-card
                  :bordered="false"
                  class="blue-card"
                  @click="selectEvent"
                >
                  <a-card-grid class="card-time" :hoverable="false">
                    <div class="white-box">
                      <p class="time-from">12:15<sub>PM</sub></p>
                      <p class="time-to">until 01:00<sub>PM</sub></p>
                      <span class="live-event">LIVE</span>
                    </div>
                  </a-card-grid>
                  <a-card-grid :hoverable="false" class="card-description">
                    <a href="#" class="card-agenda"
                      >Added to my agenda
                      <a-icon
                        class="agenda-star active"
                        type="star"
                        theme="filled"
                        style="color: #f7bb58"
                      />
                    </a>
                    <div class="card-content-container">
                      <p class="card-title">Session Title 3</p>
                      <div class="card-buttons">
                        <a href="#" class="card-button">Tag filter 2</a>
                        <a href="#" class="card-button lang"
                          ><a-icon type="flag" style="font-size: 12px" />
                          Srpski</a
                        >
                        <a href="#" class="card-button join">Join session</a>
                      </div>
                    </div>
                  </a-card-grid>
                </a-card>

                <h3 class="agenda-day">Saturday, July 10, 2021</h3>

                <a-card
                  :bordered="false"
                  class="yellow-card"
                  @click="selectEvent"
                >
                  <a-card-grid class="card-time" :hoverable="false">
                    <div class="white-box">
                      <p class="time-from">12:00<sub>PM</sub></p>
                      <p class="time-to">until 12:45<sub>PM</sub></p>
                      <span class="live-event">LIVE</span>
                    </div>
                  </a-card-grid>
                  <a-card-grid :hoverable="false" class="card-description">
                    <a href="#" class="card-agenda"
                      >{{$t('agendaNew.addToMyAgenda')}}
                      <a-icon
                        class="agenda-star"
                        type="star"
                        theme="outlined"
                        style="color: #fff"
                      />
                    </a>
                    <div class="card-content-container">
                      <p class="card-title">Session Title 4</p>
                      <div class="card-buttons">
                        <a href="#" class="card-button">Tag filter 2</a>
                        <a href="#" class="card-button lang"
                          ><a-icon type="flag" style="font-size: 12px" />
                          English</a
                        >
                        <a href="#" class="card-button join">Join session</a>
                      </div>
                    </div>
                  </a-card-grid>
                </a-card>

                <a-card
                  :bordered="false"
                  class="turquise-card"
                  @click="selectEvent"
                >
                  <a-card-grid class="card-time" :hoverable="false">
                    <div class="white-box">
                      <p class="time-from">01:00<sub>PM</sub></p>
                      <p class="time-to">until 01:45<sub>PM</sub></p>
                      <span class="live-event">LIVE</span>
                    </div>
                  </a-card-grid>
                  <a-card-grid :hoverable="false" class="card-description">
                    <a href="#" class="card-agenda"
                      >{{$t('agendaNew.addToMyAgenda')}}
                      <a-icon
                        class="agenda-star"
                        type="star"
                        theme="outlined"
                        style="color: #fff"
                      />
                    </a>
                    <div class="card-content-container">
                      <p class="card-title">Session Title 5</p>
                      <div class="card-buttons">
                        <a href="#" class="card-button">Tag filter 3</a>
                        <a href="#" class="card-button lang"
                          ><a-icon type="flag" style="font-size: 12px" />
                          Srpski</a
                        >
                        <a href="#" class="card-button join">Join session</a>
                      </div>
                    </div>
                  </a-card-grid>
                </a-card>

                <a-card
                  :bordered="false"
                  class="purple-card"
                  @click="selectEvent"
                >
                  <a-card-grid class="card-time" :hoverable="false">
                    <div class="white-box">
                      <p class="time-from">02:00<sub>PM</sub></p>
                      <p class="time-to">until 03:00<sub>PM</sub></p>
                      <span class="live-event">LIVE</span>
                    </div>
                  </a-card-grid>
                  <a-card-grid :hoverable="false" class="card-description">
                    <a href="#" class="card-agenda"
                      >{{$t('agendaNew.addToMyAgenda')}}
                      <a-icon
                        class="agenda-star"
                        type="star"
                        theme="outlined"
                        style="color: #fff"
                      />
                    </a>
                    <div class="card-content-container">
                      <p class="card-title">Session Title 4</p>
                      <div class="card-buttons">
                        <a href="#" class="card-button">Tag filter 1</a>
                        <a href="#" class="card-button lang"
                          ><a-icon type="flag" style="font-size: 12px" />
                          English</a
                        >
                        <a href="#" class="card-button join">Join session</a>
                      </div>
                    </div>
                  </a-card-grid>
                </a-card>
              </div> -->
              <div v-if="!demoEventsVisible">
                <h2 v-if="currentAgendas.length === 0">
                  {{$t('agendaNew.noAgendas')}}
                </h2>
                <agenda-table
                  :myAgendas="myAgendasUnformatted"
                  :activeAgendas="activeAgendas"
                  :passedAgendas="passedAgendas"
                  :previewClosed="previewClosed"
                  v-for="(agenda, index) in currentAgendas"
                  :key="agenda.agn_id"
                  :index="index"
                  :agenda="agenda"
                  @selectevent="selectEvent"
                  @addtomyagenda="addToMyAgenda"
                  @removefrommyagenda="deleteFromMyAgenda"
                  @filterbytag="filterByTag"
                  @closepreview="closePreview"
                >
                </agenda-table>
              </div>
            </a-col>
             <!-- Drawer for sessions -->
             <a-drawer
              placement="right"
              :visible="!previewClosed"
              :closable="false"
              :width="isMobile ? '100%' : '50%'"
              :maskClosable="true"
              class="agenda-drawer"
              @close="closePreview"
            >
            <!-- Display only for "session" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 2"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col
                  :span="24"
                  style="margin-bottom:10px"
                >
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                  :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
              </a-row>
              <a-row v-if="eventImageUrl && !isVideoLink">
                <img :src="eventImageUrl" class="session-image" />
              </a-row>
              <a-row v-if="eventImageUrl && isVideoLink">
                   <iframe :src="eventImageUrl" width="100%" height="315"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreenn></iframe>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(eventName, eventId)"
                v-if="eventLocation === 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)"
              >
                {{$t('agendaNew.join')}}</a-button
              >
              <a :href="eventJoinLink" v-if="eventLocation !== 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)" target="_blank">
                <a-button class="green-btn">{{ selectedTab == 3 ? $t('agendaNew.rewatch') : $t('agendaNew.join')}}</a-button></a
              >
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventHostedBy"
                >
                  {{$t('agendaNew.hostedBy')}}
                </p>
                <hr class="gray-hr" v-if="eventHostedBy" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventHostedBy"
                >
                  <a-col :span="6" :lg="3">
                    <img
                      :src="eventHostedByAvatar"
                      style="height: 56px; width: 56px"
                    />
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      class="sesssion-additional-info strong"
                      :href="eventHostedByUrl"
                      target="_blank"
                    >
                      {{ eventHostedBy }}
                    </a>
                    <p class="sesssion-additional-info">
                      {{ eventHostedByLocation }}
                    </p>
                  </a-col>
                </a-row>
                <p
                  class="sesssion-additional-info"
                  style="margin-top: 16px;display:none"
                >
                  <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
                </p>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="eventLecturer" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventLecturer"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="eventLecturerAvatar"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a :href="lecturerLink" target="_blank">
                      <p class="sesssion-additional-info strong">
                        {{ eventLecturer ? eventLecturer : "" }}{{ eventLecturerPosition ? ', ' + eventLecturerPosition : ''}}{{ eventLecturerCompany ? ' @ ' + eventLecturerCompany : ''}}
                      </p>
                      <p class="sesssion-additional-info">
                        {{$t('agendaNew.mainSpeaker')}}
                        <!-- CAA at Grgug d.o.o. -->
                      </p>
                    </a>
                  </a-col>
                </a-row>
                <!-- Novo additional lecturers -->


                <p
                  class="sesssion-additional-info-heading"
                  v-if="additionalSpeakers.length>0"
                >
                 {{$t('agendaNew.additionalSpeakers')}}
                </p>
                <hr class="gray-hr" v-if="additionalSpeakers.length>0" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                   v-for="item in additionalSpeakers" :key="item.usr_id"
                >
                  <a-col :span="6" :lg="3">
                    <a href="#" target="_blank">
                      <img
                        :src="speakerAvatarInitLink + item.usr_id"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      /><!-- 
                      <img
                        :src="eventLecturerAvatar"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      /> -->
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a href="#" target="_blank">
                      <p class="sesssion-additional-info strong">
                        {{getSpeakerById(item.usr_id)}}
                       <!--  {{item.speakerName}} -->
                       <!--  {{ eventLecturer ? eventLecturer : "" }}{{ eventLecturerPosition ? ', ' + eventLecturerPosition : ''}}{{ eventLecturerCompany ? ' @ ' + eventLecturerCompany : ''}} -->
                      </p>
                      <p class="sesssion-additional-info">
                        {{ item.role }}
                        <!-- CAA at Grgug d.o.o. -->
                      </p>
                    </a>
                  </a-col>
                </a-row>


              </a-row>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
            </a-col>
            <!-- Display only for "speed networking" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 3"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
<a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                  :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
</a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  style="padding-top: 0"
                >
                  {{$t('agendaNew.meetingsDuration')}}
                </p>
                <hr class="gray-hr" />
                <p
                  style="
                    color: black;
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 24px;
                  "
                >
                  <b>{{$t('agendaNew.15mins')}}</b> {{$t('agendaNew.perSession')}}
                </p>
              </a-row>
              <a-button class="green-btn">{{$t('agendaNew.joinNetworking')}}</a-button>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
            </a-col>
            <!-- Display only for "breakout sessions" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 1"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
<a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                  :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
</a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <div v-if="breakoutSessions.length > 0">
              <p
                class="sesssion-additional-info-heading"
              >
                {{$t('agendaNew.availableBreakoutSessions')}}
              </p>
              <div
                v-for="(breakoutSession, index) in breakoutSessions"
                :key="breakoutSession.agn_id"
              >
                <hr class="gray-hr" />
                <p class="sesssion-additional-info-heading">
                  {{$t('agendaNew.breakout')}} {{ index + 1 }}
                </p>
                <h1 class="breakout-heading">
                  {{ breakoutSession.agn_name }}
                </h1>
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="breakoutSession.agn_desc" disabled auto-size class="event-description" />
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="breakoutSession.usr_firstname" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  class="breakout-speaker"
                  v-if="breakoutSession.usr_firstname"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="speakerAvatarInitLink + breakoutSession.usr_id"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      :href="
                        '/profile/' +
                          breakoutSession.usr_firstname +
                          '-' +
                          breakoutSession.usr_lastname +
                          '-' +
                          breakoutSession.usr_id
                      "
                      target="_blank"
                    >
                      <p class="sesssion-additional-info strong" v-if="breakoutSession.usr_other">
                        {{ breakoutSession.usr_firstname }}
                        {{ breakoutSession.usr_lastname }}{{ JSON.parse(breakoutSession.usr_other).company_title ? ', ' + JSON.parse(breakoutSession.usr_other).company_title : ''  }} {{ JSON.parse(breakoutSession.usr_other).company_name ? '@ ' + JSON.parse(breakoutSession.usr_other).company_name : ''  }}
                      </p>
                      <p v-else>
                        {{ breakoutSession.usr_firstname }}
                         {{ breakoutSession.usr_lastname }}
                      </p>
                      <p class="sesssion-additional-info">
                         {{ breakoutSession.cmp_name }}
                      </p>
                    </a>
                  </a-col>
                </a-row>
                <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(breakoutSession.agn_name, breakoutSession.agn_id)"
                v-if="breakoutSession.loc_id === 197"
              >
                {{$t('agendaNew.joinSession')}}</a-button
              >
                <a :href="'/live/' + breakoutSession.loc_id" v-else target="_blank">
                  <a-button class="green-btn breakout"
                    >{{$t('agendaNew.joinSession')}}</a-button
                  ></a>
              </div>
              </div>
            </a-col>
            <!-- Display only for "1 on 1 meetings" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 4"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.meetingsDuration')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.10mins')}}</b> {{$t('agendaNew.perSession')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.upcommingMettings')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.pickAMeetingSlot')}}</b> {{$t('agendaNew.youWantToJoin')}}
              </p>
              <a-row align="middle" style="margin-top: 15px">
                <a-card class="meeting-card active">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:00<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="green-btn btn">{{$t('agendaNew.join')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:10<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:20<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <p class="empty-slot">{{$t('agendaNew.slot')}} 3</p>
                    <!-- <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge> -->
                  </a-card-grid>
                  <!-- <a-card-grid
                    style="width:43%;"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid> -->
                  <a-card-grid
                    class="vertical-middle"
                    style="padding: 0 !important; float: right; width: 44%"
                  >
                    <a-button
                      type="primary"
                      class="purple-meeting-btn"
                      size="large"
                    >
                      <a-icon type="clock-circle" />{{$t('agendaNew.schreduleAMeeting')}}
                    </a-button>
                  </a-card-grid>
                </a-card>
              </a-row>
              <p
                class="sesssion-additional-info-heading"
                v-if="eventDescription"
              >
                {{$t('agendaNew.description')}}
              </p>
              <hr class="gray-hr" v-if="eventDescription" />
              <p class="sesssion-additional-info" v-if="eventDescription">
                {{ eventDescription ? eventDescription : "" }}
              </p>
            </a-col>
            </a-drawer>
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab">
              <span class="active-sessions-tab" />
              {{$t('agendaNew.activeSessions')}}
            </span>
            <a-col
              id="main-card-wrap"
              :span="24"
              :lg="previewClosed ? 24 : 12"
              :style="
                previewClosed ? 'padding:24px 0' : 'padding:16px 30px 0 0'
              "
            >
              <!-- Demo events -->
              <div v-if="!demoEventsVisible">
                <h2 v-if="activeAgendasObj.length === 0">
                  {{$t('agendaNew.noActiveSesssions')}}
                </h2>
                <agenda-table
                  :myAgendas="myAgendasUnformatted"
                  :activeAgendas="activeAgendas"
                  :passedAgendas="passedAgendas"
                  :previewClosed="previewClosed"
                  v-for="(agenda, index) in activeAgendasObj"
                  :key="agenda.agn_id"
                  :index="index"
                  :agenda="agenda"
                  @selectevent="selectEvent"
                  @addtomyagenda="addToMyAgenda"
                  @removefrommyagenda="deleteFromMyAgenda"
                  @filterbytag="filterByTag"
                  @closepreview="closePreview"
                ></agenda-table>
              </div>
            </a-col>
            
            <!-- Drawer for sessions -->
            <a-drawer
              placement="right"
              :visible="!previewClosed"
              :closable="false"
              :width="isMobile ? '100%' : '50%'"
              :maskClosable="true"
              @close="closePreview"
            >
            <!-- Display only for "session" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 2"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">                
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
              </a-row>
              <a-row v-if="eventImageUrl && !isVideoLink">
                <img :src="eventImageUrl" class="session-image" />
              </a-row>
              <a-row v-if="eventImageUrl && isVideoLink">
                   <iframe :src="eventImageUrl" width="100%" height="315"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreenn></iframe>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(eventName, eventId)"
                v-if="eventLocation === 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)"
              >
                {{$t('agendaNew.join')}}</a-button
              >
              <a :href="eventJoinLink" v-if="eventLocation !== 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)" target="_blank">
                <a-button class="green-btn">{{ selectedTab == 3 ? $t('agendaNew.rewatch') : $t('agendaNew.join')}}</a-button></a
              >
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventHostedBy"
                >
                  {{$t('agendaNew.hostedBy')}}
                </p>
                <hr class="gray-hr" v-if="eventHostedBy" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventHostedBy"
                >
                  <a-col :span="6" :lg="3">
                    <img
                      :src="eventHostedByAvatar"
                      style="height: 56px; width: 56px"
                    />
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      class="sesssion-additional-info strong"
                      :href="eventHostedByUrl"
                      target="_blank"
                    >
                      {{ eventHostedBy }}
                    </a>
                    <p class="sesssion-additional-info">
                      {{ eventHostedByLocation }}
                    </p>
                  </a-col>
                </a-row>
                <p
                  class="sesssion-additional-info"
                  style="margin-top: 16px;display:none"
                >
                  <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
                </p>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="eventLecturer" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventLecturer"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="eventLecturerAvatar"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a :href="lecturerLink" target="_blank">
                      <p class="sesssion-additional-info strong">
                        {{ eventLecturer ? eventLecturer : "" }}{{ eventLecturerPosition ? ', ' + eventLecturerPosition : ''}}{{ eventLecturerCompany ? ' @ ' + eventLecturerCompany : ''}}
                      </p>
                      <p class="sesssion-additional-info">
                        {{ eventSpeakerRole }}
                        <!-- CAA at Grgug d.o.o. -->
                      </p>
                    </a>
                  </a-col>
                </a-row>
              </a-row>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
            </a-col>
            <!-- Display only for "speed networking" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 3"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  style="padding-top: 0"
                >
                  {{$t('agendaNew.meetingsDuration')}}
                </p>
                <hr class="gray-hr" />
                <p
                  style="
                    color: black;
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 24px;
                  "
                >
                  <b>{{$t('agendaNew.15mins')}}</b> {{$t('agendaNew.perSession')}}
                </p>
              </a-row>
              <a-button class="green-btn">{{$t('agendaNew.joinNetworking')}}</a-button>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
            </a-col>
            <!-- Display only for "breakout sessions" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 1"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <div v-if="breakoutSessions.length > 0">
              <p
                class="sesssion-additional-info-heading"
              >
                {{$t('agendaNew.availableBreakoutSessions')}}
              </p>
              <div
                v-for="(breakoutSession, index) in breakoutSessions"
                :key="breakoutSession.agn_id"
              >
                <hr class="gray-hr" />
                <p class="sesssion-additional-info-heading">
                  {{$t('agendaNew.breakout')}} {{ index + 1 }}
                </p>
                <h1 class="breakout-heading">
                  {{ breakoutSession.agn_name }}
                </h1>
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="breakoutSession.agn_desc" disabled auto-size class="event-description" />
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="eventLecturer" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  class="breakout-speaker"
                  v-if="eventLecturer"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="speakerAvatarInitLink + breakoutSession.usr_id"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      :href="
                        '/profile/' +
                          breakoutSession.usr_firstname +
                          '-' +
                          breakoutSession.usr_lastname +
                          '-' +
                          breakoutSession.usr_id
                      "
                      target="_blank"
                    >
                      <p class="sesssion-additional-info strong" v-if="breakoutSession.usr_other">
                        {{ breakoutSession.usr_firstname }}
                        {{ breakoutSession.usr_lastname }}{{ JSON.parse(breakoutSession.usr_other).company_title ? ', ' + JSON.parse(breakoutSession.usr_other).company_title : ''  }} {{ JSON.parse(breakoutSession.usr_other).company_name ? '@ ' + JSON.parse(breakoutSession.usr_other).company_name : ''  }}
                      </p>
                      <p v-else>
                        {{ breakoutSession.usr_firstname }}
                         {{ breakoutSession.usr_lastname }}
                      </p>
                      <p class="sesssion-additional-info">
                         {{ breakoutSession.cmp_name }}
                      </p>
                    </a>
                  </a-col>
                </a-row>
                <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(breakoutSession.agn_name, breakoutSession.agn_id)"
                v-if="breakoutSession.loc_id === 197"
              >
                {{$t('agendaNew.joinSession')}}</a-button
              >
                <a :href="'/live/' + breakoutSession.loc_id" v-else target="_blank">
                  <a-button class="green-btn breakout"
                    >{{$t('agendaNew.joinSession')}}</a-button
                  ></a>
              </div>
              </div>
            </a-col>
            <!-- Display only for "1 on 1 meetings" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 4"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.meetingsDuration')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.10mins')}}</b> {{$t('agendaNew.perSession')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.upcommingMettings')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.pickAMeetingSlot')}}</b> {{$t('agendaNew.youWantToJoin')}}
              </p>
              <a-row align="middle" style="margin-top: 15px">
                <a-card class="meeting-card active">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:00<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="green-btn btn">{{$t('agendaNew.join')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:10<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:20<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <p class="empty-slot">{{$t('agendaNew.slot')}} 3</p>
                    <!-- <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge> -->
                  </a-card-grid>
                  <!-- <a-card-grid
                    style="width:43%;"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid> -->
                  <a-card-grid
                    class="vertical-middle"
                    style="padding: 0 !important; float: right; width: 44%"
                  >
                    <a-button
                      type="primary"
                      class="purple-meeting-btn"
                      size="large"
                    >
                      <a-icon type="clock-circle" />{{$t('agendaNew.schreduleAMeeting')}}
                    </a-button>
                  </a-card-grid>
                </a-card>
              </a-row>
              <p
                class="sesssion-additional-info-heading"
                v-if="eventDescription"
              >
                {{$t('agendaNew.description')}}
              </p>
              <hr class="gray-hr" v-if="eventDescription" />
              <p class="sesssion-additional-info" v-if="eventDescription">
                {{ eventDescription ? eventDescription : "" }}
              </p>
            </a-col>
             </a-drawer>
          </a-tab-pane>
          <a-tab-pane key="3" :tab="$t('agendaNew.rewatchTitle')" v-if="fairConfig.FC_PASSED_AGENDA == 1">
            <a-col
              id="main-card-wrap"
              :span="24"
              :lg="previewClosed ? 24 : 12"
              :style="
                previewClosed ? 'padding:24px 0' : 'padding:16px 30px 0 0'
              "
            >
              <!-- Demo events -->
              <div v-if="!demoEventsVisible">
                <h2 v-if="passedAgendasObj.length === 0">
                  {{$t('agendaNew.noAgendas')}}
                </h2>
                <agenda-table
                  :myAgendas="myAgendasUnformatted"
                  :activeAgendas="activeAgendas"
                  :passedAgendas="passedAgendas"
                  :previewClosed="previewClosed"
                  v-for="(agenda, index) in passedAgendasObj"
                  :key="index"
                  :index="index"
                  :agenda="agenda"
                  @selectevent="selectEvent"
                  @addtomyagenda="addToMyAgenda"
                  @removefrommyagenda="deleteFromMyAgenda"
                  @filterbytag="filterByTag"
                  @closepreview="closePreview"
                ></agenda-table>
              </div>
            </a-col>
            <!-- Drawer for sessions -->
            <a-drawer
              placement="right"
              :visible="!previewClosed"
              :closable="false"
              :width="isMobile ? '100%' : '50%'"
              :maskClosable="true"
              @close="closePreview"
            >
            <!-- Display only for "session" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 2"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">                
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
              </a-row>
              <a-row v-if="eventImageUrl && !isVideoLink">
                <img :src="eventImageUrl" class="session-image" />
              </a-row>
              <a-row v-if="eventImageUrl && isVideoLink">
                   <iframe :src="eventImageUrl" width="100%" height="315"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreenn></iframe>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(eventName, eventId)"
                v-if="eventLocation === 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)"
              >
                {{$t('agendaNew.join')}}</a-button
              >
              <a :href="eventJoinLink" v-if="eventLocation !== 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)" target="_blank">
                <a-button class="green-btn">{{ selectedTab == 3 ? $t('agendaNew.rewatch') : $t('agendaNew.join')}}</a-button></a
              >
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventHostedBy"
                >
                  {{$t('agendaNew.hostedBy')}}
                </p>
                <hr class="gray-hr" v-if="eventHostedBy" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventHostedBy"
                >
                  <a-col :span="6" :lg="3">
                    <img
                      :src="eventHostedByAvatar"
                      style="height: 56px; width: 56px"
                    />
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      class="sesssion-additional-info strong"
                      :href="eventHostedByUrl"
                      target="_blank"
                    >
                      {{ eventHostedBy }}
                    </a>
                    <p class="sesssion-additional-info">
                      {{ eventHostedByLocation }}
                    </p>
                  </a-col>
                </a-row>
                <p
                  class="sesssion-additional-info"
                  style="margin-top: 16px;display:none"
                >
                  <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
                </p>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="eventLecturer" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventLecturer"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="eventLecturerAvatar"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a :href="lecturerLink" target="_blank">
                      <p class="sesssion-additional-info strong">
                        {{ eventLecturer ? eventLecturer : "" }}{{ eventLecturerPosition ? ', ' + eventLecturerPosition : ''}}{{ eventLecturerCompany ? ' @ ' + eventLecturerCompany : ''}}
                      </p>
                      <p class="sesssion-additional-info">
                        {{ eventSpeakerRole }}
                        <!-- CAA at Grgug d.o.o. -->
                      </p>
                    </a>
                  </a-col>
                </a-row>
              </a-row>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
            </a-col>
            <!-- Display only for "speed networking" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 3"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  style="padding-top: 0"
                >
                  {{$t('agendaNew.meetingsDuration')}}
                </p>
                <hr class="gray-hr" />
                <p
                  style="
                    color: black;
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 24px;
                  "
                >
                  <b>{{$t('agendaNew.15mins')}}</b> {{$t('agendaNew.perSession')}}
                </p>
              </a-row>
              <a-button class="green-btn">{{$t('agendaNew.joinNetworking')}}</a-button>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
            </a-col>
            <!-- Display only for "breakout sessions" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 1"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <div v-if="breakoutSessions.length > 0">
              <p
                class="sesssion-additional-info-heading"
              >
                {{$t('agendaNew.availableBreakoutSessions')}}
              </p>
              <div
                v-for="(breakoutSession, index) in breakoutSessions"
                :key="breakoutSession.agn_id"
              >
                <hr class="gray-hr" />
                <p class="sesssion-additional-info-heading">
                  {{$t('agendaNew.breakout')}} {{ index + 1 }}
                </p>
                <h1 class="breakout-heading">
                  {{ breakoutSession.agn_name }}
                </h1>
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="breakoutSession.agn_desc" disabled auto-size class="event-description" />
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="eventLecturer" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  class="breakout-speaker"
                  v-if="eventLecturer"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="speakerAvatarInitLink + breakoutSession.usr_id"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      :href="
                        '/profile/' +
                          breakoutSession.usr_firstname +
                          '-' +
                          breakoutSession.usr_lastname +
                          '-' +
                          breakoutSession.usr_id
                      "
                      target="_blank"
                    >
                      <p class="sesssion-additional-info strong" v-if="breakoutSession.usr_other">
                        {{ breakoutSession.usr_firstname }}
                        {{ breakoutSession.usr_lastname }}{{ JSON.parse(breakoutSession.usr_other).company_title ? ', ' + JSON.parse(breakoutSession.usr_other).company_title : ''  }} {{ JSON.parse(breakoutSession.usr_other).company_name ? '@ ' + JSON.parse(breakoutSession.usr_other).company_name : ''  }}
                      </p>
                      <p v-else>
                        {{ breakoutSession.usr_firstname }}
                         {{ breakoutSession.usr_lastname }}
                      </p>
                      <p class="sesssion-additional-info">
                         {{ breakoutSession.cmp_name }}
                      </p>
                    </a>
                  </a-col>
                </a-row>
                <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(breakoutSession.agn_name, breakoutSession.agn_id)"
                v-if="breakoutSession.loc_id === 197"
              >
                {{$t('agendaNew.joinSession')}}</a-button
              >
                <a :href="'/live/' + breakoutSession.loc_id" v-else target="_blank">
                  <a-button class="green-btn breakout"
                    >{{$t('agendaNew.joinSession')}}</a-button
                  ></a>
              </div>
              </div>
            </a-col>
            <!-- Display only for "1 on 1 meetings" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 4"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.meetingsDuration')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.10mins')}}</b> {{$t('agendaNew.perSession')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.upcommingMettings')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.pickAMeetingSlot')}}</b> {{$t('agendaNew.youWantToJoin')}}
              </p>
              <a-row align="middle" style="margin-top: 15px">
                <a-card class="meeting-card active">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:00<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="green-btn btn">{{$t('agendaNew.join')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:10<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:20<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <p class="empty-slot">{{$t('agendaNew.slot')}} 3</p>
                    <!-- <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge> -->
                  </a-card-grid>
                  <!-- <a-card-grid
                    style="width:43%;"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid> -->
                  <a-card-grid
                    class="vertical-middle"
                    style="padding: 0 !important; float: right; width: 44%"
                  >
                    <a-button
                      type="primary"
                      class="purple-meeting-btn"
                      size="large"
                    >
                      <a-icon type="clock-circle" />{{$t('agendaNew.schreduleAMeeting')}}
                    </a-button>
                  </a-card-grid>
                </a-card>
              </a-row>
              <p
                class="sesssion-additional-info-heading"
                v-if="eventDescription"
              >
                {{$t('agendaNew.description')}}
              </p>
              <hr class="gray-hr" v-if="eventDescription" />
              <p class="sesssion-additional-info" v-if="eventDescription">
                {{ eventDescription ? eventDescription : "" }}
              </p>
            </a-col>
             </a-drawer>
          </a-tab-pane>
          <a-tab-pane key="4">
            <span slot="tab">
              {{$t('agendaNew.myAgenda')}} <b>({{ myAgendasLength }})</b>
            </span>
            <a-col
              id="main-card-wrap"
              :span="24"
              :lg="previewClosed ? 24 : 12"
              :style="
                previewClosed ? 'padding:24px 0' : 'padding:16px 30px 0 0'
              "
            >
              <div>
                <h2 v-if="myAgendas.length === 0">
                  {{$t('agendaNew.noMyAgenda')}}
                </h2>
                <agenda-table
                  :myAgendas="myAgendasUnformatted"
                  :activeAgendas="activeAgendas"
                  :passedAgendas="passedAgendas"
                  :previewClosed="previewClosed"
                  v-for="(agenda, index) in myAgendas"
                  :key="agenda.agn_id"
                  :index="index"
                  :agenda="agenda"
                  @selectevent="selectEvent"
                  @addtomyagenda="addToMyAgenda"
                  @removefrommyagenda="deleteFromMyAgenda"
                  @filterbytag="filterByTag"
                  @closepreview="closePreview"
                >
                </agenda-table>
              </div>
            </a-col>
            <!-- Drawer for sessions -->
            <a-drawer
              placement="right"
              :visible="!previewClosed"
              :closable="false"
              :width="isMobile ? '100%' : '50%'"
              :maskClosable="true"
              @close="closePreview"
            >
            <!-- Display only for "session" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 2"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.session')}}</h4>
              </a-row>
              <a-row v-if="eventImageUrl && !isVideoLink">
                <img :src="eventImageUrl" class="session-image" />
              </a-row>
              <a-row v-if="eventImageUrl && isVideoLink">
                   <iframe :src="eventImageUrl" width="100%" height="315"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreenn></iframe>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(eventName, eventId)"
                v-if="eventLocation === 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)"
              >
                {{$t('agendaNew.join')}}</a-button
              >
              <a :href="eventJoinLink" v-if="eventLocation !== 'Networking' && (sid || fairConfig.FC_PUBLIC == 1)" target="_blank">
                <a-button class="green-btn">{{ selectedTab == 3 ? $t('agendaNew.rewatch') : $t('agendaNew.join')}}</a-button></a
              >
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventHostedBy"
                >
                  {{$t('agendaNew.hostedBy')}}
                </p>
                <hr class="gray-hr" v-if="eventHostedBy" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventHostedBy"
                >
                  <a-col :span="6" :lg="3">
                    <img
                      :src="eventHostedByAvatar"
                      style="height: 56px; width: 56px"
                    />
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      class="sesssion-additional-info strong"
                      :href="eventHostedByUrl"
                      target="_blank"
                    >
                      {{ eventHostedBy }}
                    </a>
                    <p class="sesssion-additional-info">
                      {{ eventHostedByLocation }}
                    </p>
                  </a-col>
                </a-row>
                <p
                  class="sesssion-additional-info"
                  style="margin-top: 16px;display:none"
                >
                  <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
                </p>
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="eventLecturer" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  v-if="eventLecturer"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="eventLecturerAvatar"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a :href="lecturerLink" target="_blank">
                      <p class="sesssion-additional-info strong">
                        {{ eventLecturer ? eventLecturer : "" }}{{ eventLecturerPosition ? ', ' + eventLecturerPosition : ''}}{{ eventLecturerCompany ? ' @ ' + eventLecturerCompany : ''}}
                      </p>
                      <p class="sesssion-additional-info">
                        {{ eventSpeakerRole }}
                        <!-- CAA at Grgug d.o.o. -->
                      </p>
                    </a>
                  </a-col>
                </a-row>
              </a-row>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
            </a-col>
            <!-- Display only for "speed networking" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 3"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.speedNetworking')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <a-row>
                <p
                  class="sesssion-additional-info-heading"
                  style="padding-top: 0"
                >
                  {{$t('agendaNew.meetingsDuration')}}
                </p>
                <hr class="gray-hr" />
                <p
                  style="
                    color: black;
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 24px;
                  "
                >
                  <b>{{$t('agendaNew.15mins')}}</b> {{$t('agendaNew.perSession')}}
                </p>
              </a-row>
              <a-button class="green-btn">{{$t('agendaNew.joinNetworking')}}</a-button>
              <a-row v-if="eventDescription">
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="eventDescription" disabled auto-size class="event-description" />
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
            </a-col>
            <!-- Display only for "breakout sessions" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 1"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
                <a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
                </a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.breakoutSessions')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <div v-if="breakoutSessions.length > 0">
              <p
                class="sesssion-additional-info-heading"
              >
                {{$t('agendaNew.availableBreakoutSessions')}}
              </p>
              <div
                v-for="(breakoutSession, index) in breakoutSessions"
                :key="breakoutSession.agn_id"
              >
                <hr class="gray-hr" />
                <p class="sesssion-additional-info-heading">
                  {{$t('agendaNew.breakout')}} {{ index + 1 }}
                </p>
                <h1 class="breakout-heading">
                  {{ breakoutSession.agn_name }}
                </h1>
                <p class="sesssion-additional-info-heading">{{$t('agendaNew.description')}}</p>
                <hr class="gray-hr" />
                <a-textarea  :value="breakoutSession.agn_desc" disabled auto-size class="event-description" />
                <p
                  class="sesssion-additional-info-heading"
                  v-if="eventLecturer"
                >
                  {{$t('agendaNew.speakers')}}
                </p>
                <hr class="gray-hr" v-if="eventLecturer" />
                <a-row
                  type="flex"
                  justify="space-around"
                  align="middle"
                  style="margin-top: 1.5em"
                  class="breakout-speaker"
                  v-if="eventLecturer"
                >
                  <a-col :span="6" :lg="3">
                    <a :href="lecturerLink" target="_blank">
                      <img
                        :src="speakerAvatarInitLink + breakoutSession.usr_id"
                        style="height: 56px; width: 56px; border-radius: 50%"
                      />
                    </a>
                  </a-col>
                  <a-col :span="18" :lg="21">
                    <a
                      :href="
                        '/profile/' +
                          breakoutSession.usr_firstname +
                          '-' +
                          breakoutSession.usr_lastname +
                          '-' +
                          breakoutSession.usr_id
                      "
                      target="_blank"
                    >
                      <p class="sesssion-additional-info strong" v-if="breakoutSession.usr_other">
                        {{ breakoutSession.usr_firstname }}
                        {{ breakoutSession.usr_lastname }}{{ JSON.parse(breakoutSession.usr_other).company_title ? ', ' + JSON.parse(breakoutSession.usr_other).company_title : ''  }} {{ JSON.parse(breakoutSession.usr_other).company_name ? '@ ' + JSON.parse(breakoutSession.usr_other).company_name : ''  }}
                      </p>
                      <p v-else>
                        {{ breakoutSession.usr_firstname }}
                         {{ breakoutSession.usr_lastname }}
                      </p>
                      <p class="sesssion-additional-info">
                         {{ breakoutSession.cmp_name }}
                      </p>
                    </a>
                  </a-col>
                </a-row>
                <a-button
                class="green-btn"
                style="height: 40px; border-radius: 0; vertical-align: 0.05em;"
                v-on:click="joinBBBMeeting(breakoutSession.agn_name, breakoutSession.agn_id)"
                v-if="breakoutSession.loc_id === 197"
              >
                {{$t('agendaNew.joinSession')}}</a-button
              >
                <a :href="'/live/' + breakoutSession.loc_id" v-else target="_blank">
                  <a-button class="green-btn breakout"
                    >{{$t('agendaNew.joinSession')}}</a-button
                  ></a>
              </div>
              </div>
            </a-col>
            <!-- Display only for "1 on 1 meetings" type -->
            <a-col
              v-if="!previewClosed && eventTypeId === 4"
              :span="24"
              :lg="24"
              class="agenda-details-wrap"
            >
              <a-row>
                <a-col :span="24" style="margin-bottom:10px">
                  <a class="close-preview" @click="closePreview">
                    {{$t('agendaNew.close')}}
                    <a-icon
                      type="close-circle"
                      theme="outlined"
                      style="
                        color: black;
                        vertical-align: -0.25em;
                        font-size: 21px;
                      "
                    />
                  </a>
                </a-col>
                
                <a-row class="mobile-only">
                  <div id="scrollAnchor" style="height:50px" />
                  <h2 class="session-heading">
                    {{ eventName ? eventName : "" }}
                    <a-icon
                      v-if="isEventInMyAgenda(eventId)"
                      type="star"
                      theme="filled"
                      style="color: #f7bb58"
                    />
                  </h2>
                </a-row>
                <a-row class="mobile-only">
                  <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
                </a-row>
                <h3 class="agenda-day gray">{{ eventDate }}</h3>
<a-row type="flex" align="top">
                <a-button
                  v-if="!isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="addToAgenda(eventId)"
                  >{{$t('agendaNew.addToMyAgenda')}}
                </a-button>
                <a-button
                  v-if="isEventInMyAgenda(eventId)"
                  class="align-right add-to-agenda-btn"
                  @click="deleteFromMyAgenda(eventId)"
                  >{{$t('agendaNew.removeFromMyAgenda')}}
                </a-button>
                <a-select
                  class="align-right add-to-calendar-btn"
                   :default-value="$t('agendaNew.addToCalendar')"
                  @select="addToCalendar"
                  v-model="selectedCalendar"
                  size="large"
                >
                  >
                  <a-select-option :value="$t('agendaNew.googleCalendar')">
                    {{$t('agendaNew.googleCalendar')}}
                  </a-select-option>
                  <a-select-option
                    :value="$t('agendaNew.microsoftCalendar')"
                    class="add-to-calendar-option"
                  >
                    {{$t('agendaNew.microsoftCalendar')}}
                  </a-select-option>
                  <a-select-option :value="$t('agendaNew.yahoo')" class="add-to-calendar-option">
                    {{$t('agendaNew.yahoo')}}
                  </a-select-option>
                </a-select>
</a-row>
              </a-row>
              <a-row class="desktop-only">
                <h2 class="session-heading">
                  {{ eventName ? eventName : "" }}
                  <a-icon
                    v-if="isEventInMyAgenda(eventId)"
                    type="star"
                    theme="filled"
                    style="color: #f7bb58"
                  />
                </h2>
              </a-row>
              <a-row class="desktop-only">
                <h4 class="session-type">{{$t('agendaNew.1on1meetings')}}</h4>
              </a-row>
              <a-row class="time-information">
                <a-col :span="6">
                  <p class="session-description-heading">{{$t('agendaNew.startTime')}}</p>
                  <p class="session-description">
                    {{ eventFrom ? eventFrom : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.endTime')}}</p>
                  <p class="session-description">
                    {{ eventTo ? eventTo : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: center">
                  <p class="session-description-heading">{{$t('agendaNew.duration')}}</p>
                  <p class="session-description">
                    {{ eventDuration ? eventDuration + $t('agendaNew.minutes') : "" }}
                  </p>
                </a-col>
                <a-col :span="6" style="text-align: right">
                  <p class="session-description-heading">{{$t('agendaNew.location')}}</p>
                  <p class="session-description">{{ eventLocation }}</p>
                </a-col>
              </a-row>
              <p
                class="sesssion-additional-info"
                style="margin-top: 16px;display:none"
              >
                <a-icon type="user" />{{$t('agendaNew.noOfParticipants')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.meetingsDuration')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.10mins')}}</b> {{$t('agendaNew.perSession')}}
              </p>
              <p class="sesssion-additional-info-heading">{{$t('agendaNew.upcommingMettings')}}</p>
              <hr class="gray-hr" />
              <p class="sesssion-additional-info">
                <b>{{$t('agendaNew.pickAMeetingSlot')}}</b> {{$t('agendaNew.youWantToJoin')}}
              </p>
              <a-row align="middle" style="margin-top: 15px">
                <a-card class="meeting-card active">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:00<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="green-btn btn">{{$t('agendaNew.join')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:10<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 43%"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid>
                  <a-card-grid style="width: 5%; padding: 0 !important">
                    <a-popover trigger="click">
                      <a slot="content">{{$t('agendaNew.editSlot')}}</a>
                      <a-button
                        type="link"
                        icon="more"
                        style="color: #c4c4c4; font-size: 40px"
                        size="large"
                        class="vertical-middle"
                      />
                    </a-popover>
                  </a-card-grid>
                </a-card>
              </a-row>
              <a-row align="middle">
                <a-card class="meeting-card">
                  <a-card-grid
                    style="
                      width: 27%;
                      flex-direction: column;
                      padding: 16px !important;
                    "
                    class="vertical-middle meeting-time"
                  >
                    <p class="time">11:20<sub> AM</sub></p>
                    <p class="date">Friday, July 9</p>
                  </a-card-grid>
                  <a-card-grid style="width: 1%; padding: 0 !important">
                    <div class="vertical-line"></div>
                  </a-card-grid>
                  <a-card-grid
                    style="width: 20%; text-align: center"
                    :hoverable="false"
                    class="meeting-speaker vertical-middle"
                  >
                    <p class="empty-slot">{{$t('agendaNew.slot')}} 3</p>
                    <!-- <a-badge dot status="success" title="online">
                      <a-avatar icon="user" src="" size="large" />
                    </a-badge> -->
                  </a-card-grid>
                  <!-- <a-card-grid
                    style="width:43%;"
                    :hoverable="false"
                    class="vertical-middle speaker-info"
                  >
                    <p class="meeting-speaker-name">Marko Obrenović</p>
                    <p class="meeting-speaker-role">Product Designer</p>
                    <a-button class="yellow-btn btn">{{$t('agendaNew.comingUp')}}</a-button>
                  </a-card-grid> -->
                  <a-card-grid
                    class="vertical-middle"
                    style="padding: 0 !important; float: right; width: 44%"
                  >
                    <a-button
                      type="primary"
                      class="purple-meeting-btn"
                      size="large"
                    >
                      <a-icon type="clock-circle" />{{$t('agendaNew.schreduleAMeeting')}}
                    </a-button>
                  </a-card-grid>
                </a-card>
              </a-row>
              <p
                class="sesssion-additional-info-heading"
                v-if="eventDescription"
              >
                {{$t('agendaNew.description')}}
              </p>
              <hr class="gray-hr" v-if="eventDescription" />
              <p class="sesssion-additional-info" v-if="eventDescription">
                {{ eventDescription ? eventDescription : "" }}
              </p>
            </a-col>
             </a-drawer>
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>

    <!-- <div class="ics-wrap">
      <a :href="agendasDownloadLink">{{ $t('agenda.getAllCalendar') }} <img :src="$images.ics" alt=""></a>
    </div> -->

    <!--  <agenda-booths></agenda-booths> -->

    <!-- Delete modal -->
    <a-modal
      :visible="deleteModalVisible"
      @ok="confirmDelete"
      @cancel="closeDeleteModal"
    >{{$t('agendaNew.confirmRemoveFromMyAgenda')}}
    </a-modal>

  </div>
  <div class="message" v-else>
    <h3>{{ message }}</h3>
  </div>
</template>

<script>
import { mapState } from "vuex";
import api from "../api";
import axios from 'axios';
import AgendaTable from "../components/agenda/AgendaTable";
/* import AgendaBooths from "../components/agenda/AgendaBooths";
 */ import moment from "moment";
//import ValidateVue from "../components/auth/Validate.vue";

export default {
  components: {
    AgendaTable,
    /*     AgendaBooths,
     */
  },
  props: {
    orientation: Boolean,
  },
  data() {
    return {
      selectedTab: '1',
      deleteModalVisible: false,
      agendaItemToDelete: null,
      eventSpeakerRole: null,
      agendas: [],
      activeAgendas: [],
      passedAgendas: [],
      activeAgendasObj: [],
      passedAgendasObj: [],
      currentlyShowingAgendas: [],
      backupAgendas: [],
      backupActiveAgendas: [],
      backupPassedAgendas: [],
      backupMyAgendas: [],
      myAgendas: [],
      myAgendasLength: 0,
      myAgendasUnformatted: [],
      noData: false,
      message: "",
      searchText: "",
      booths: [],
      boothLinks: [],
      selectedTimezoneOffset: -new Date().getTimezoneOffset() / 60,
      eventId: "",
      eventDescription: "",
      eventFrom: "",
      eventTo: "",
      eventDuration: "",
      eventDate: "",
      eventName: "",
      eventLecturer: null,
      eventTypeId: "",
      eventLecturerId: "",
      eventLecturerAvatar: require("../assets/placeholder-speaker.png"),
      eventLecturerPosition: "",
      eventLecturerCompany: "",
      eventLocation: "",
      eventAdditionalInfo: "",
      eventImageUrl: null,
      eventHostedBy: "",
      eventHostedByLocation: "",
      eventHostedByUrl: "",
      eventHostedByAvatar: require("../assets/placeholder-host.png"),
      eventJoinLink: "",
      demoEventsVisible: false,
      noOfAdditionalFilters: "0",
      previewClosed: true,
      currentDateTime: new Date(),
      allAgendas: [],
      allDays: [],
      uniqueDays: [],
      selectedDay: this.$t('agendaNew.allDays'),
      allLocations: [],
      uniqueLocations: [],
      selectedLocation: this.$t('agendaNew.allLocations'),
      allExhibitors: [],
      uniqueExhibitors: [],
      selectedExhibitor: this.$t('agendaNew.allSpeakers'),
      allTags: [],
      selectedTag: [],
      breakoutSessions: [],
      speakerAvatarInitLink:
        process.env.VUE_APP_API_URL +
        "/users/image?sid=" +
        localStorage.getItem("sid") +
        "&usr_id=",
      timezones: [
        { timezone: "UTC-12:00", value: "-12:00" },
        { timezone: "UTC-11:00", value: "-11:00" },
        { timezone: "UTC-10:00", value: "-10:00" },
        { timezone: "UTC-09:00", value: "-09:00" },
        { timezone: "UTC-08:00", value: "-08:00" },
        { timezone: "UTC-07:00", value: "-07:00" },
        { timezone: "UTC-06:00", value: "-06:00" },
        { timezone: "UTC-05:00", value: "-05:00" },
        { timezone: "UTC-04:30", value: "-04:30" },
        { timezone: "UTC-04:00", value: "-04:00" },
        { timezone: "UTC-03:30", value: "-03:30" },
        { timezone: "UTC-03:00", value: "-03:00" },
        { timezone: "UTC-02:00", value: "-02:00" },
        { timezone: "UTC-01:00", value: "-01:00" },
        { timezone: "UTC+00:00", value: "+00:00" },
        { timezone: "UTC+01:00", value: "+01:00" },
        { timezone: "UTC+02:00", value: "+02:00" },
        { timezone: "UTC+03:00", value: "+03:00" },
        { timezone: "UTC+03:30", value: "+03:30" },
        { timezone: "UTC+04:00", value: "+04:00" },
        { timezone: "UTC+04:30", value: "+04:30" },
        { timezone: "UTC+05:00", value: "+05:00" },
        { timezone: "UTC+05:30", value: "+05:30" },
        { timezone: "UTC+05:45", value: "+05:45" },
        { timezone: "UTC+06:00", value: "+06:00" },
        { timezone: "UTC+06:30", value: "+06:30" },
        { timezone: "UTC+07:00", value: "+07:00" },
        { timezone: "UTC+08:00", value: "+08:00" },
        { timezone: "UTC+09:00", value: "+09:00" },
        { timezone: "UTC+09:30", value: "+09:30" },
        { timezone: "UTC+10:00", value: "+10:00" },
        { timezone: "UTC+11:00", value: "+11:00" },
        { timezone: "UTC+12:00", value: "+12:00" },
        { timezone: "UTC+13:00", value: "+13:00" },
      ],
      selectedTimeZone: "",
      selectedEvent: "",
      lecturerLink: "",
      filtersDrawerVisible: false,
      dayCheckBoxOptions: ["All days"],
      locationCheckBoxOptions: ["All locations"],
      exhibitorCheckBoxOptions: ["All speakers"],
      isMobile: false,
      googleCalendarLink: '',
      userName: 'dummyName',
      userType: 'user',
      meetingId: 'dummyMeeting',
      usrId: null,
      additionalSpeakers:[],
      additionalSpeakersNew:[],
      uniqeuSpeakers:[],
      currentAgendas:[],
      isVideoLink: false,
      selectedCalendar: this.$t('agendaNew.addToCalendar'),
    }
  },
  watch: {
    additionalSpeakers: function (val) {
      this.additionalSpeakersNew = [];
      this.additionalSpeakers.forEach(additionalSpeaker => {
        this.additionalSpeakerName(additionalSpeaker.usr_id, additionalSpeaker.role)
      })
    },
  },
  computed: {
    agendasDownloadLink() {
      return "/api/calendar?sid=" + localStorage.getItem("sid");
    },
    agendaDownload() {
      return (
        process.env.VUE_APP_API_URL +
        "/agenda/pdf?sid=" +
        localStorage.getItem("sid")
      );
      //return "/api/agenda/pdf?sid=81";
    },
    sid() {
      return localStorage.getItem("sid");
    },
    ...mapState(["fairConfig"]),
  },
  created() {
    this.init();
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.isMobile = true;
    }
  },
  beforeRouteUpdate (to, from, next) {
    let nweUrl =  to.fullPath;
     if(nweUrl.includes('activeSessions')){
        this.selectedTab = '2';
       // this.setInitialData();
      }
      else{
        this.selectedTab = '1';
       // this.setInitialData();
      }
    next()
  },
  methods: {
    getSpeakerById(id){
      let obj = this.additionalSpeakersNew.find(o => o.userId === id);
      return obj.speakerName;
    },

    async additionalSpeakerName(userId, role){
          await api.getProfile(userId).then((response) => {
              this.additionalSpeakersNew.push(
                {
                  userId : userId,
                  speakerName : response.data.user.firstname + ' ' + response.data.user.usr_lastname,
                  role: role,
                }
              );
          })
    },
    
    async getUserName(userId){
        await api.getProfile(userId).then((response) => {
          this.usrId = response.data.user.usr_id;
          this.userName = response.data.user.firstname + ' ' + response.data.user.usr_lastname; // + '+' + response.data.user.usr_lastname
          this.userType = response.data.user.type;
        })
    },

    async joinBBBMeeting(eventName, eventId){
      let currentSid = localStorage.getItem("sid");
      this.meetingId = eventId + '-' + eventName;

      //let createUrl = 'https://beyond1.doc.ba/api/checksum?action=create&user=' + this.userName+'&meeting=' + this.meetingId;
      //let createUrl = 'https://hrweek.collectivibe.com/api/users/bbb?action=create&user=' + this.userName+'&meeting=' + this.meetingId + '&type=' + this.userType + '&usr_id=' + this.usrId;
      let createUrl =  process.env.VUE_APP_API_URL + '/users/bbb?action=create&sid='+currentSid+'&meeting=' + this.meetingId;
      /* Get the create meeting link */
      await axios.get(createUrl).then((response) => {
         let responseCreateUrl = JSON.parse(response.request.response).createUrl;
         this.getCreateMeeting(responseCreateUrl);
         });
    },

      /* Create the actual meeting */
    async getCreateMeeting(url){
       await axios.get(url).then((response) => {
            if(response.status === 200){
              /* The meeting has been created / already exists, join user */
              this.joinMeeting();
            }
          })
    },

      /* Join the meeting */
    async joinMeeting(){
        let currentSid = localStorage.getItem("sid");
        //let joinUrl = 'https://hrweek.collectivibe.com/api/users/bbb?action=join&user=' + this.userName+'&meeting=' + this.meetingId + '&type=' + this.userType + '&usr_id=' + this.usrId;
        let joinUrl =  process.env.VUE_APP_API_URL + '/users/bbb?action=join&sid=' + currentSid +'&meeting=' + this.meetingId;

        await axios.get(joinUrl).then((response) => {
         let responseJoinURL = JSON.parse(response.request.response).joinUrl;
         window.open(responseJoinURL, '_blank').focus();
         });
    },

    /* Create join link for Google calendar */
    
    async getBBBLink(eventName, eventId){
        let currentSid = localStorage.getItem("sid");
      

      this.meetingId = eventId + '-' +eventName;
      //let createUrl = 'https://beyond1.doc.ba/api/checksum?action=create&user=' + this.userName+'&meeting=' + this.meetingId;
     // let createUrl = 'https://hrweek.collectivibe.com/api/users/bbb?action=create&sid=' + this.userName+'&meeting=' + this.meetingId + '&type=' + this.userType + '&usr_id=' + this.usrId;
     
     let createUrl =  process.env.VUE_APP_API_URL + '/users/bbb?action=create&sid=' + currentSid +'&meeting=' + this.meetingId;
      /* Get the create meeting link */
      await axios.get(createUrl).then((response) => {
         let responseCreateUrl = JSON.parse(response.request.response).createUrl;
         this.getCreateMeetingLink(responseCreateUrl);
         });
    },

      /* Create the actual meeting */
    async getCreateMeetingLink(url){
       await axios.get(url).then((response) => {
            if(response.status === 200){
              /* The meeting has been created / already exists, join user */
              this.getJoinLink();
            }
          })
    },

      /* Join the meeting */
    async getJoinLink(){
        let currentSid = localStorage.getItem("sid");

        //let joinUrl = 'https://hrweek.collectivibe.com/api/users/bbb?action=join&user=' + this.userName+'&meeting=' + this.meetingId + '&type=' + this.userType + '&usr_id=' + this.usrId;
        let joinUrl =  process.env.VUE_APP_API_URL + '/users/bbb?action=join&sid='  + currentSid +'&meeting=';

        await axios.get(joinUrl).then((response) => {
         let responseJoinURL = JSON.parse(response.request.response).joinUrl;
         this.googleCalendarLink = responseJoinURL;
         //window.open(responseJoinURL, '_blank').focus();
         });
    },


    async init() {
      /* Trenutno sakrivanje sidebara na agenda page */
      /* var sidebar = document.getElementsByClassName("side-bar-wrap")[0];
      sidebar.style.display = "none"; */

      /* Get user name */
      //this.getUserName(localStorage.usr_id);

      let currentURL = window.location.href;

       if(currentURL.includes('activeSessions')){
        this.selectedTab = '2';
      }
      else{
        this.selectedTab = '1';
      }

      let currentDate = new Date();
      let currentTimeZone = currentDate.getTimezoneOffset() / 60;
      let currentTimeZoneFormatted;
      if (currentTimeZone.toString().length === 2) {
        currentTimeZoneFormatted =
          currentTimeZone.toString()[0] +
          "0" +
          currentTimeZone.toString()[1] +
          ":00";
      } else {
        currentTimeZoneFormatted = currentTimeZone.toString() + ":00";
      }

      this.selectedTimeZone = currentTimeZoneFormatted;

      this.startLoading();
      await this.getAgendas();
      await this.getMyAgendas();
      this.stopLoading();
      api.mixpanel({ event: "clicked_agenda_link" });
      await this.getBooths();
      this.currentAgendas.length <=  0 ? this.selectedTab = '3' : this.selectedTab = '1';
    },
    compare(a, b) {
      if (a.agn_from < b.agn_from) {
        return -1;
      }
      if (a.agn_from > b.agn_from) {
        return 1;
      }
      return 0;
    },
    async getAgendas() {
      try {
        let res = await api.getAgendas();
        // response from server held temporarily
        let agendas = res.data.data;
        // update server time to local time
        let localFromDateTime;
        let localToDateTime;
        for (let i = 0; i < agendas.length; i++) {
          localToDateTime = this.convertStringToTimezone(
            agendas[i].agn_to,
            this.selectedTimezoneOffset
          );
          localFromDateTime = this.convertStringToTimezone(
            agendas[i].agn_from,
            this.selectedTimezoneOffset
          );
          agendas[i].agn_from = moment(
            localFromDateTime,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD HH:mm:ss");
          agendas[i].agn_to = moment(
            localToDateTime,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD HH:mm:ss");
        }

        let prepTags;

        agendas.forEach((agenda) => {
          this.allLocations.push({
            loc_id: agenda.loc_id,
            loc_name: agenda.loc_name,
          });

          this.allDays.push(agenda.agn_from.split(" ")[0]);

          this.allExhibitors.push({
            speaker_id: agenda.speaker_id,
            usr_firstname: agenda.usr_firstname,
            usr_lastname: agenda.usr_lastname,
          });

          // add tags as array
          if (agenda.tags) {
            if (agenda.tags.includes(",")) {
              prepTags = agenda.tags.split(",");
              prepTags.forEach((tag) => {
                if (!this.allTags.includes(tag)) {
                  this.allTags.push(tag);
                }
              });
              agenda.tags = prepTags;
            } else {
              prepTags = agenda.tags;
              if (!this.allTags.includes(prepTags)) {
                this.allTags.push(prepTags);
              }
              agenda.tags = [prepTags];
            }
          }
        });
        this.allAgendas = agendas;
        this.currentlyShowingAgendas = agendas;

        // set unique locations for filter

        const map = new Map();
        for (const item of this.allLocations) {
          if (!map.has(item.loc_id)) {
            map.set(item.loc_id, true); // set any value to Map
            this.uniqueLocations.push({
              loc_id: item.loc_id,
              loc_name: item.loc_name,
            });
            if (item.loc_name) {
              let checkBoxOptions = {
                label: item.loc_name,
                value: item.loc_id,
              };
              this.locationCheckBoxOptions.push(checkBoxOptions);
            }
          }
        }

        // set unique days for filter

        let uniqueDays = [...new Set(this.allDays)];

        uniqueDays.forEach((day) => {
          let date = new Date(day).toDateString();
          let splitDate = date.split(" ");
          let formattedDate =
            splitDate[0] + ", " + splitDate[1] + " " + splitDate[2];

          let completeDate = {
            date: day,
            dateString: formattedDate,
          };

          let checkBoxOptions = {
            label: formattedDate,
            value: day,
          };

          this.dayCheckBoxOptions.push(checkBoxOptions);

          this.uniqueDays.push(completeDate);
        });

        // set unique exhibitors for filter

        const mapExhibitors = new Map();
        for (const item of this.allExhibitors) {
          if (!mapExhibitors.has(item.speaker_id)) {
            mapExhibitors.set(item.speaker_id, true); // set any value to Map
            this.uniqueExhibitors.push({
              speaker_id: item.speaker_id,
              usr_firstname: item.usr_firstname,
              usr_lastname: item.usr_lastname,
            });

            let checkBoxOptions = {
              label: item.usr_firstname + " " + item.usr_lastname,
              value: item.speaker_id,
            };

            this.exhibitorCheckBoxOptions.push(checkBoxOptions);
          }
        }

        // holds agendas grouped by date
        let agendaObj = {};

        // Go through all items by datefrom and group them into agendaObj
        if (!res.data.data) {
          this.handleNoAgenda(res.data.message);
          return;
        }
        for (let i = 0; i < agendas.length; i++) {
          agendas[i].displayMoreInfo = false;
          var tAgn = agendas[i];
          let agnDateFrom = moment(tAgn.agn_from, "YYYY-MM-DD HH:mm:ss").format(
            "YYYY-MM-DD"
          );
          // If this is the first agenda for a day - make new array
          if (agendaObj[agnDateFrom] === undefined) {
            agendaObj[agnDateFrom] = [];
          }
          agendaObj[agnDateFrom].push(tAgn);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allDates = Object.keys(agendaObj);
        allDates.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedAgendas = [];
        for (let i = 0; i < allDates.length; i++) {
          sortedAgendas.push({
            groupDate: allDates[i],
            dayAgendas: agendaObj[allDates[i]],
          });
        }
        this.agendas = sortedAgendas;
        
           /* Filter for only upcomoing sessions */
        sortedAgendas.forEach((agenda) => {
         agenda.dayAgendas.forEach((dayAgenda) => {
            let dayAgendaFrom = dayAgenda.agn_from;
            let dayAgendaTo = dayAgenda.agn_to;

            let currentTimeFormatted = moment(
              this.currentDateTime,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD HH:mm:ss");

            if (
              dayAgendaTo > currentTimeFormatted
            ) {
               if (
                !this.currentAgendas.filter(
                  (agenda) => agenda.agn_id === dayAgenda.agn_id
                ).length > 0
              ) {
                this.currentAgendas.push(dayAgenda);
              }
            }
         })
        })
           // holds agendas grouped by date
        let currentAgendaObj = {};

        for (let i = 0; i < this.currentAgendas.length; i++) {
          this.currentAgendas[i].displayMoreInfo = false;
          var cAgn = this.currentAgendas[i];
          let agnDateFrom = moment(cAgn.agn_from, "YYYY-MM-DD HH:mm:ss").format(
            "YYYY-MM-DD"
          );
          // If this is the first agenda for a day - make new array
          if (currentAgendaObj[agnDateFrom] === undefined) {
            currentAgendaObj[agnDateFrom] = [];
          }
          currentAgendaObj[agnDateFrom].push(cAgn);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allCurrentDates = Object.keys(currentAgendaObj);
        allCurrentDates.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedCurrentAgendas = [];
        for (let i = 0; i < allCurrentDates.length; i++) {
          sortedCurrentAgendas.push({
            groupDate: allCurrentDates[i],
            dayAgendas: currentAgendaObj[allCurrentDates[i]],
          });
        }
        this.currentAgendas = sortedCurrentAgendas;
        
        this.backupAgendas = this.currentAgendas;
        // Set active and passed agendas
        sortedAgendas.forEach((agenda) => {
          // dayAgendas, groupDate

          agenda.dayAgendas.forEach((dayAgenda) => {
            let dayAgendaFrom = dayAgenda.agn_from;
            let dayAgendaTo = dayAgenda.agn_to;

            let currentTimeFormatted = moment(
              this.currentDateTime,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD HH:mm:ss");

            if (
              dayAgendaFrom < currentTimeFormatted &&
              dayAgendaTo > currentTimeFormatted
            ) {
              if (
                !this.activeAgendas.filter(
                  (agenda) => agenda.agn_id === dayAgenda.agn_id
                ).length > 0
              ) {
                this.activeAgendas.push(dayAgenda);
              }
            } else if (dayAgendaTo < currentTimeFormatted) {
              if (
                !this.passedAgendas.filter(
                  (agenda) => agenda.agn_id === dayAgenda.agn_id
                ).length > 0
              ) {
                this.passedAgendas.push(dayAgenda);
              }
            }
          });

          agenda.dayAgendas.sort(this.compare);
        });

        // holds agendas grouped by date
        let passedAgendaObj = {};

        for (let i = 0; i < this.passedAgendas.length; i++) {
          this.passedAgendas[i].displayMoreInfo = false;
          var tAgn2 = this.passedAgendas[i];
          let agnDateFrom = moment(
            tAgn2.agn_from,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD");
          // If this is the first agenda for a day - make new array
          if (passedAgendaObj[agnDateFrom] === undefined) {
            passedAgendaObj[agnDateFrom] = [];
          }
          passedAgendaObj[agnDateFrom].push(tAgn2);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allDates2 = Object.keys(passedAgendaObj);
        allDates2.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedAgendas2 = [];
        for (let i = 0; i < allDates2.length; i++) {
          sortedAgendas2.push({
            groupDate: allDates2[i],
            dayAgendas: passedAgendaObj[allDates2[i]],
          });
        }
        this.passedAgendasObj = sortedAgendas2;
        this.backupPassedAgendas = sortedAgendas2;

        // holds agendas grouped by date
        let activeAgendaObj = {};

        for (let i = 0; i < this.activeAgendas.length; i++) {
          this.activeAgendas[i].displayMoreInfo = false;
          var tAgn3 = this.activeAgendas[i];
          let agnDateFrom = moment(
            tAgn3.agn_from,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD");
          // If this is the first agenda for a day - make new array
          if (activeAgendaObj[agnDateFrom] === undefined) {
            activeAgendaObj[agnDateFrom] = [];
          }
          activeAgendaObj[agnDateFrom].push(tAgn3);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allDates3 = Object.keys(activeAgendaObj);
        allDates3.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedAgendas3 = [];
        for (let i = 0; i < allDates3.length; i++) {
          sortedAgendas3.push({
            groupDate: allDates3[i],
            dayAgendas: activeAgendaObj[allDates3[i]],
          });
        }
        this.activeAgendasObj = sortedAgendas3;
        this.backupActiveAgendas = sortedAgendas3;
      } catch (error) {
        this.handleError(error);
      }

      // this.setInitialData();
    },

    /* setInitialData(){

        switch (this.selectedTab) {
          case '1':
            if(this.currentAgendas.length > 0) {
              this.selectEvent(this.currentAgendas[0].dayAgendas[0]);
            }
            break;
          case '2':
            if (this.activeAgendasObj.length > 0){
              this.selectEvent(this.activeAgendasObj[0].dayAgendas[0]);
            }
            break;
          case '3':
            if (this.passedAgendasObj.length > 0){
              this.selectEvent(this.passedAgendasObj[0].dayAgendas[0]);
            }
          break;
          case '4':
            if (this.myAgendas.length > 0){
              this.selectEvent(this.myAgendas[0].dayAgendas[0]);
            }
          break;
          default:
            break;
        }
    }, */

    async getFilteredAgendas(filters) {
      try {
        let res = await api.getFilteredAgendas(filters);
        // response from server held temporarily
        let agendas = res.data.data;

        // update server time to local time
        let localFromDateTime;
        let localToDateTime;
        for (let i = 0; i < agendas.length; i++) {
          localToDateTime = this.convertStringToTimezone(
            agendas[i].agn_to,
            this.selectedTimezoneOffset
          );
          localFromDateTime = this.convertStringToTimezone(
            agendas[i].agn_from,
            this.selectedTimezoneOffset
          );
          agendas[i].agn_from = moment(
            localFromDateTime,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD HH:mm:ss");
          agendas[i].agn_to = moment(
            localToDateTime,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD HH:mm:ss");
        }

        this.currentlyShowingAgendas = agendas;

        let prepTags;

        this.activeAgendas = [];
        this.passedAgendas = [];

        if (agendas) {
          agendas.forEach((agenda) => {
            // add tags as array
            if (agenda.tags) {
              if (agenda.tags.includes(",")) {
                prepTags = agenda.tags.split(",");
                prepTags.forEach((tag) => {
                  if (!this.allTags.includes(tag)) {
                    this.allTags.push(tag);
                  }
                });
                agenda.tags = prepTags;
              } else {
                prepTags = agenda.tags;
                if (!this.allTags.includes(prepTags)) {
                  this.allTags.push(prepTags);
                }
                agenda.tags = [prepTags];
              }
            }
          });
        } else {
          agendas = [];
          this.agendas = [];
          this.passedAgendas = [];
        }

        // holds agendas grouped by date
        let agendaObj = {};
        /*
        // Go through all items by datefrom and group them into agendaObj
        if (!res.data.data) {
          this.agendas = [];
          return;
        } */
        for (let i = 0; i < agendas.length; i++) {
          agendas[i].displayMoreInfo = false;
          var tAgn = agendas[i];
          let agnDateFrom = moment(tAgn.agn_from, "YYYY-MM-DD HH:mm:ss").format(
            "YYYY-MM-DD"
          );
          // If this is the first agenda for a day - make new array
          if (agendaObj[agnDateFrom] === undefined) {
            agendaObj[agnDateFrom] = [];
          }
          agendaObj[agnDateFrom].push(tAgn);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allDates = Object.keys(agendaObj);
        allDates.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedAgendas = [];
        for (let i = 0; i < allDates.length; i++) {
          sortedAgendas.push({
            groupDate: allDates[i],
            dayAgendas: agendaObj[allDates[i]],
          });
        }
        this.agendas = sortedAgendas;

        // Set active and passed agendas
        sortedAgendas.forEach((agenda) => {
          // dayAgendas, groupDate

          agenda.dayAgendas.forEach((dayAgenda) => {
            let dayAgendaFrom = dayAgenda.agn_from;
            let dayAgendaTo = dayAgenda.agn_to;

            let currentTimeFormatted = moment(
              this.currentDateTime,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD HH:mm:ss");

            if (
              dayAgendaFrom < currentTimeFormatted &&
              dayAgendaTo > currentTimeFormatted
            ) {
              if (
                !this.activeAgendas.filter(
                  (agenda) => agenda.agn_id === dayAgenda.agn_id
                ).length > 0
              ) {
                this.activeAgendas.push(dayAgenda);
              }
            } else if (dayAgendaTo < currentTimeFormatted) {
              if (
                !this.passedAgendas.filter(
                  (agenda) => agenda.agn_id === dayAgenda.agn_id
                ).length > 0
              ) {
                this.passedAgendas.push(dayAgenda);
              }
            }
          });

          agenda.dayAgendas.sort(this.compare);
        });

        // holds agendas grouped by date
        let passedAgendaObj = {};

        for (let i = 0; i < this.passedAgendas.length; i++) {
          this.passedAgendas[i].displayMoreInfo = false;
          var tAgn2 = this.passedAgendas[i];
          let agnDateFrom = moment(
            tAgn2.agn_from,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD");
          // If this is the first agenda for a day - make new array
          if (passedAgendaObj[agnDateFrom] === undefined) {
            passedAgendaObj[agnDateFrom] = [];
          }
          passedAgendaObj[agnDateFrom].push(tAgn2);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allDates2 = Object.keys(passedAgendaObj);
        allDates2.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedAgendas2 = [];
        for (let i = 0; i < allDates2.length; i++) {
          sortedAgendas2.push({
            groupDate: allDates2[i],
            dayAgendas: passedAgendaObj[allDates2[i]],
          });
        }
        this.passedAgendasObj = sortedAgendas2;
        this.backupPassedAgendas = sortedAgendas2;

        // holds agendas grouped by date
        let activeAgendaObj = {};

        for (let i = 0; i < this.activeAgendas.length; i++) {
          this.activeAgendas[i].displayMoreInfo = false;
          var tAgn3 = this.activeAgendas[i];
          let agnDateFrom = moment(
            tAgn3.agn_from,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD");
          // If this is the first agenda for a day - make new array
          if (activeAgendaObj[agnDateFrom] === undefined) {
            activeAgendaObj[agnDateFrom] = [];
          }
          activeAgendaObj[agnDateFrom].push(tAgn3);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allDates3 = Object.keys(activeAgendaObj);
        allDates3.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedAgendas3 = [];
        for (let i = 0; i < allDates3.length; i++) {
          sortedAgendas3.push({
            groupDate: allDates3[i],
            dayAgendas: activeAgendaObj[allDates3[i]],
          });
        }
        this.activeAgendasObj = sortedAgendas3;
        this.backupActiveAgendas = sortedAgendas3;
      } catch (error) {
        this.handleError(error);
      }
     // this.setInitialData();
    },

    async getMyAgendaFiltered(filters) {
      let currentSid = localStorage.getItem("sid");
      if (currentSid) {
        try {
          let res = await api.getMyAgendaFiltered(filters);
          // response from server held temporarily
          let agendas = res.data.data;

          let prepTags;
          if (agendas && agendas.length > 0) {
            agendas.forEach((agenda) => {
              // add tags as array
              if (agenda.tags) {
                if (agenda.tags.includes(",")) {
                  prepTags = agenda.tags.split(",");
                  prepTags.forEach((tag) => {
                    if (!this.allTags.includes(tag)) {
                      this.allTags.push(tag);
                    }
                  });
                  agenda.tags = prepTags;
                } else {
                  prepTags = agenda.tags;
                  if (!this.allTags.includes(prepTags)) {
                    this.allTags.push(prepTags);
                  }
                  agenda.tags = [prepTags];
                }
              }
            });

            let date1 = new Date(agendas[0].agn_from);
            let date2 = new Date(agendas[0].agn_to);
            let duration = (date2.getTime() - date1.getTime()) / (1000 * 60); // get duration of event in minutes

            this.eventDuration = duration;
            this.eventFrom = moment(
              agendas[0].agn_from,
              "YYYY-MM-DD HH:mm:ss"
            ).format("h:mm A"); // format time AM / PM
            this.eventTo = moment(
              agendas[0].agn_to,
              "YYYY-MM-DD HH:mm:ss"
            ).format("h:mm A");

            // update server time to local time
            let localFromDateTime;
            let localToDateTime;
            let newTags;
            for (let i = 0; i < agendas.length; i++) {
              localToDateTime = this.convertStringToTimezone(
                agendas[i].agn_to,
                this.selectedTimezoneOffset
              );
              localFromDateTime = this.convertStringToTimezone(
                agendas[i].agn_from,
                this.selectedTimezoneOffset
              );
              agendas[i].agn_from = moment(
                localFromDateTime,
                "YYYY-MM-DD HH:mm:ss"
              ).format("YYYY-MM-DD HH:mm:ss");
              agendas[i].agn_to = moment(
                localToDateTime,
                "YYYY-MM-DD HH:mm:ss"
              ).format("YYYY-MM-DD HH:mm:ss");
            }
          }

          // holds agendas grouped by date
          let agendaObj = {};

          // Go through all items by datefrom and group them into agendaObj
          /*  if (!res.data.data) {
          this.agendas = [];
          return;
        } */
          if (agendas) {
            for (let i = 0; i < agendas.length; i++) {
              agendas[i].displayMoreInfo = false;
              var tAgn = agendas[i];
              let agnDateFrom = moment(
                tAgn.agn_from,
                "YYYY-MM-DD HH:mm:ss"
              ).format("YYYY-MM-DD");
              // If this is the first agenda for a day - make new array
              if (agendaObj[agnDateFrom] === undefined) {
                agendaObj[agnDateFrom] = [];
              }
              agendaObj[agnDateFrom].push(tAgn);
            }
          }
          // Make an array of all agenda dates and sort by date - asc
          var allDates = Object.keys(agendaObj);
          allDates.sort((a, b) => {
            let aMom = moment(a);
            let bMom = moment(b);
            if (aMom.isBefore(bMom)) return -1;
            if (aMom.isAfter(bMom)) return 1;
            return 0;
          });

          // Make sure that we have agendas grouped by date
          let sortedAgendas = [];
          for (let i = 0; i < allDates.length; i++) {
            sortedAgendas.push({
              groupDate: allDates[i],
              dayAgendas: agendaObj[allDates[i]],
            });
          }

          sortedAgendas.forEach((agenda) => {
            agenda.dayAgendas.sort(this.compare);
          });
          this.myAgendas = sortedAgendas;
          this.backupMyAgendas = this.myAgendas;
        } catch (error) {
          this.handleError(error);
        }
       // this.setInitialData();
      }
    },

    async getBreakoutSessions(session_id) {
      try {
        let res = await api.getBreakoutSessions(session_id);
        // response from server held temporarily
        let breakoutSessions = res.data.result;
        this.breakoutSessions = breakoutSessions;
      } catch (error) {
        this.handleError(error);
      }
    },

    selectTab(event) {
      this.selectedTab = event.toString();
    //  this.setInitialData();
      //this.$router.push('agenda');
      // if tab == "my agenda"
      if (event == 4) {
        this.getMyAgendas();
      }
      this.closePreview();
    },

    async getMyAgendas() {
      let currentSid = localStorage.getItem("sid");

      if (currentSid) {
        try {
          let res = await api.getMyAgenda();
          // response from server held temporarily
          let agendas = res.data.data;
          this.myAgendasUnformatted = agendas;
          this.myAgendasLength = agendas.length;
          let prepTags;
          this.currentlyShowingAgendas = agendas;

          if (agendas.length > 0) {
            agendas.forEach((agenda) => {
              // add tags as array
              if (agenda.tags) {
                if (agenda.tags.includes(",")) {
                  prepTags = agenda.tags.split(",");
                  prepTags.forEach((tag) => {
                    if (!this.allTags.includes(tag)) {
                      this.allTags.push(tag);
                    }
                  });
                  agenda.tags = prepTags;
                } else {
                  prepTags = agenda.tags;
                  if (!this.allTags.includes(prepTags)) {
                    this.allTags.push(prepTags);
                  }
                  agenda.tags = [prepTags];
                }
              }
            });
/* 
            let date1 = new Date(agendas[0].agn_from);
            let date2 = new Date(agendas[0].agn_to);
            let duration = (date2.getTime() - date1.getTime()) / (1000 * 60); // get duration of event in minutes

            this.eventDuration = duration;
            this.eventFrom = moment(
              agendas[0].agn_from,
              "YYYY-MM-DD HH:mm:ss"
            ).format("h:mm A"); // format time AM / PM
            this.eventTo = moment(
              agendas[0].agn_to,
              "YYYY-MM-DD HH:mm:ss"
            ).format("h:mm A"); */

            // update server time to local time
            let localFromDateTime;
            let localToDateTime;
            let newTags;
            for (let i = 0; i < agendas.length; i++) {
              localToDateTime = this.convertStringToTimezone(
                agendas[i].agn_to,
                this.selectedTimezoneOffset
              );
              localFromDateTime = this.convertStringToTimezone(
                agendas[i].agn_from,
                this.selectedTimezoneOffset
              );
              agendas[i].agn_from = moment(
                localFromDateTime,
                "YYYY-MM-DD HH:mm:ss"
              ).format("YYYY-MM-DD HH:mm:ss");
              agendas[i].agn_to = moment(
                localToDateTime,
                "YYYY-MM-DD HH:mm:ss"
              ).format("YYYY-MM-DD HH:mm:ss");
            }
          }

          // holds agendas grouped by date
          let agendaObj = {};

          // Go through all items by datefrom and group them into agendaObj
          /*  if (!res.data.data) {
          this.agendas = [];
          return;
        } */
          for (let i = 0; i < agendas.length; i++) {
            agendas[i].displayMoreInfo = false;
            var tAgn = agendas[i];
            let agnDateFrom = moment(
              tAgn.agn_from,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD");
            // If this is the first agenda for a day - make new array
            if (agendaObj[agnDateFrom] === undefined) {
              agendaObj[agnDateFrom] = [];
            }
            agendaObj[agnDateFrom].push(tAgn);
          }

          // Make an array of all agenda dates and sort by date - asc
          var allDates = Object.keys(agendaObj);
          allDates.sort((a, b) => {
            let aMom = moment(a);
            let bMom = moment(b);
            if (aMom.isBefore(bMom)) return -1;
            if (aMom.isAfter(bMom)) return 1;
            return 0;
          });

          // Make sure that we have agendas grouped by date
          let sortedAgendas = [];
          for (let i = 0; i < allDates.length; i++) {
            sortedAgendas.push({
              groupDate: allDates[i],
              dayAgendas: agendaObj[allDates[i]],
            });
          }

          sortedAgendas.forEach((agenda) => {
            agenda.dayAgendas.sort(this.compare);
          });

          this.myAgendas = sortedAgendas;
          this.backupMyAgendas = this.myAgendas;
        } catch (error) {
          this.handleError(error);
        }
      }
    },

    async addToMyAgenda(agnId) {
      let sid = localStorage.getItem("sid");
      if(sid){
        if (
        !this.myAgendasUnformatted.filter((agenda) => agenda.agn_id === agnId)
          .length > 0
        ) {
          try {
            let res = await api.postMyAgenda(agnId);
            this.$message.success("Successfully added to my agenda");
          } catch (error) {
            this.handleError(error);
          }
        } else {
          this.$message.success("Selected agenda already added to my agenda");
        }

      this.getMyAgendas();
      }

      else{
         this.$message.error("You have to login to add to your agenda");
         this.$router.push("/login")
      }
      
    },

     deleteFromMyAgenda(agnId) {
      // set modal visibility to true
      this.deleteModalVisible = true;
      this.agendaItemToDelete = agnId;     
    },

    async confirmDelete(){
      if(this.agendaItemToDelete){
        try {
          await api.deleteMyAgenda(this.agendaItemToDelete);
          this.$message.success("Successfully removed from my agenda");
          this.getMyAgendas();
          this.closePreview();
          /* PROVJERITI DA LI OVO RADITI */
          /* if(this.myAgendas.length>0){
            this.selectEvent(this.myAgendasUnformatted[0]);
            console.log("this.myAgendas: ", this.myAgendasUnformatted)
          } */
        } catch (error) {
          this.handleError(error);
          this.$message.success("Error removing from my agenda");
        }
      }
      this.closeDeleteModal();
    },

    closeDeleteModal(){
      this.deleteModalVisible = false;
    },

    addToAgenda(eventId) {
      this.addToMyAgenda(eventId);
      setTimeout(() => this.getMyAgendas(), 300);
      //this.closePreview();
    },

    isEventInMyAgenda(eventId) {
      if (
        this.myAgendasUnformatted.filter((agenda) => agenda.agn_id === eventId)
          .length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    convertStringToTimezone(datetime, offsetHours) {
      offsetHours = parseInt(offsetHours);
      let tempMoment = moment(datetime);
      tempMoment.add(offsetHours, "hours");
      return tempMoment;
    },
    async getBooths() {
      const apiObj = {
        api: api.getAllBooths,
      };
      const data = await this.apiCall(apiObj);
      if (data) {
        this.booths = data.boothdata;
      }
    },
    handleNoAgenda(message) {
      this.noData = true;
      this.message = message;
    },
    addToCalendar(event) {
      console.log("change event, vrijednost je: ", this.selectedCalendar, ", event je: ", event);
        if (event === "Google calendar") {
          

          if(this.eventLocation == 'Networking'){
            this.getBBBLink(this.selectedEvent.agn_name, this.selectedEvent.agn_id);
            window.open(this.googleCalendarLink);
          }
          /* Other links */
          else{
            window.open(this.googleCalendarLink);
          }

        //document.getElementById("googleCalendar").click();
      } else {
        let link =
          process.env.VUE_APP_API_URL +
          "/calendar?agn_id=" +
          this.selectedEvent.agn_id +
          "&sid=" +
          localStorage.getItem("sid");

        window.open(link);
      }
      this.selectedCalendar = "Add to calendar";
    },

    selectEvent(event) {
      let newFrom = event.agn_from.replaceAll('-', '/');
      
        let JSONadditional = event.agn_additional ? JSON.parse(event.agn_additional) : null;
        
        if(JSONadditional && JSONadditional.speakers){
              let additionalSpeakers = JSONadditional.speakers;
              this.additionalSpeakers = additionalSpeakers ? additionalSpeakers : [];
        }

      let newFromDate = new Date(newFrom).toISOString();
      

      let stringFromDate =  newFromDate.toString();

      let firstFormatStringFromDate = stringFromDate.replaceAll('-', '');

      let secondFromatStringFromDate = firstFormatStringFromDate.replaceAll(':', '');

      let finalFormatStringFromDate = secondFromatStringFromDate.replaceAll('.', '');

      let newTo = event.agn_to.replaceAll('-', '/');

      let newToDate = new Date(newTo).toISOString();
      

      let stringToDate =  newToDate.toString();

      let firstFormatStringToDate = stringToDate.replaceAll('-', '');

      let secondFromatStringToDate = firstFormatStringToDate.replaceAll(':', '');

      let finalFormatStringToDate = secondFromatStringToDate.replaceAll('.', '');
     
        let link = 'https://calendar.google.com/calendar/u/0/r/eventedit';
        let dates = '?dates=' + finalFormatStringFromDate + '/' + finalFormatStringToDate;
        let details = '&details=' + (event.agn_desc ? event.agn_desc : '');
        let text = '&text=' + event.agn_name;
        let location = '&location=' + window.location.origin + '/live/' + event.loc_id;
        let fullLink = link + dates + details + text + location;
        this.googleCalendarLink = fullLink;

      this.selectedEvent = event;
      this.lecturerLink =
        "/profile/" +
        event.usr_firstname +
        "-" +
        event.usr_lastname +
        "-" +
        event.speaker_id;

      if (event.agt_id === 1) {
        this.getBreakoutSessions(event.agn_id);
      }

      let speakerAvatar =
        process.env.VUE_APP_API_URL +
        `/users/image?usr_id=${event.speaker_id}&sid=` +
        localStorage.getItem("sid");

      let companyAvatar =
        process.env.VUE_APP_API_URL +
        `/companies/image?cmp_id=${event.agn_hosted_by}&sid=` +
        localStorage.getItem("sid");

      this.eventId = event.agn_id;
      this.eventDescription = event.agn_desc;
      this.eventName = event.agn_name;
      if (event.usr_firstname || event.usr_lastname) {
        this.eventLecturer = event.usr_firstname + " " + event.usr_lastname;
        let usrOther = event.usr_other ? JSON.parse(event.usr_other) : null;
        if(usrOther){  
          this.eventLecturerPosition = usrOther.company_title;
          this.eventLecturerCompany = usrOther.company_name;
        }
      } else {
        this.eventLecturer = null;
      }
      this.eventTypeId = event.agt_id;
      this.eventLocation = event.loc_name;
      this.eventLecturerId = event.speaker_id;
      this.eventLecturerAvatar = speakerAvatar;
      this.eventHostedBy = event.hosted_by_name;
      this.eventHostedByLocation = event.hosted_by_location;
      this.eventHostedByUrl = event.hosted_by_url;
      this.eventHostedByAvatar = companyAvatar;
      this.eventJoinLink = "/live/" + event.loc_id;
      if (event.agn_additional) {
      this.eventAdditionalInfo = event.agn_additional ? JSON.parse(event.agn_additional) : null;
        
      this.eventImageUrl = this.eventAdditionalInfo.imageUrl ? this.eventAdditionalInfo.imageUrl : null;
        // setting speaker role
        if(this.eventAdditionalInfo.speakerRole){
          this.eventSpeakerRole = this.eventAdditionalInfo.speakerRole;
        }
        else{
          this.eventSpeakerRole = null;
        }
        // session type
        if (this.eventAdditionalInfo.videoUrl) {
          if(this.eventAdditionalInfo.videoUrl.includes('youtube.com')){
            // video link - youtube
            let videoId = this.eventAdditionalInfo.videoUrl.split('?v=')[1];
            if(!this.eventAdditionalInfo.imageUrl){
              this.eventImageUrl = 'https://www.youtube.com/embed/' + videoId;
              this.isVideoLink = true;
            }
            else{
              this.isVideoLink = false;
            }
            this.eventJoinLink = this.eventJoinLink + '?video_src=' + 'https://www.youtube.com/embed/' + videoId;
          }
          else if(this.eventAdditionalInfo.videoUrl.includes('vimeo.com')){
            // video link - vimeo
            let videoId = this.eventAdditionalInfo.videoUrl.split('vimeo.com/')[1];
            if(!this.eventAdditionalInfo.imageUrl){
              this.eventImageUrl = 'https://player.vimeo.com/video/' + videoId;
              this.isVideoLink = true;
            }
            else{
              this.isVideoLink = false;
            }
            this.eventJoinLink = this.eventJoinLink + '?video_src=' + 'https://player.vimeo.com/video/' + videoId;
          }
        }
        else{
            // image link
            this.eventImageUrl = this.eventAdditionalInfo.imageUrl;
            this.isVideoLink = false;
          }
      }
      else{
        // not set
          this.eventImageUrl = null;
          this.isVideoLink = false;
        }


      let date1 = new Date(event.agn_from);
      let date2 = new Date(event.agn_to);
      let duration = (date2.getTime() - date1.getTime()) / (1000 * 60); // get duration of event in minutes

      /* New - Moment - support for Safari */

      if (event.agn_from !== "") {
        this.eventDate = moment(event.agn_from, "YYYY-MM-DD").format(
          "dddd, MMMM Do YYYY"
        ); 
      }
      
      /* OLD */
     
     /*  let stringDate = date1.toDateString();
      let prepDate = stringDate.split(" ");
      let finalDate =
        prepDate[0] +
        ", " +
        prepDate[1] +
        " " +
        prepDate[2] +
        ", " +
        prepDate[3];
      this.eventDate = finalDate.toString(); */

      this.eventDuration = duration;
      this.eventFrom = moment(event.agn_from, "YYYY-MM-DD HH:mm:ss").format(
        "h:mm A"
      ); // format time AM / PM
      this.eventTo = moment(event.agn_to, "YYYY-MM-DD HH:mm:ss").format(
        "h:mm A"
      );
      this.previewClosed = false;

      //window.scrollTo({ top: 0, behavior: "smooth" });
    },

    showDemoEvents() {
      this.demoEventsVisible = !this.demoEventsVisible;
    },

    closePreview() {
      this.previewClosed = true;
      console.log("clicked!");
    },

    filterBtnNoClick() {
      document.getElementsByClassName("filter-btn")[0].click();
    },

    filterByTag(tag) {
      this.selectedTag = [tag];
      this.handleAnyFilterChange();
    },

    handleAnyFilterChange() {
      if (this.selectedTag.length === 1) {
        this.noOfAdditionalFilters = 0;
      } else if (this.selectedTag.length > 1) {
        this.noOfAdditionalFilters =
          "+" + (this.selectedTag.length - 1).toString();
      } else {
        this.noOfAdditionalFilters = 0;
      }

      let uslov = {
        tags: this.selectedTag.length === 0 ? "" : this.selectedTag,
        day: this.selectedDay === "All days" ? "" : this.selectedDay,
        loc:
          this.selectedLocation === "All locations"
            ? ""
            : this.selectedLocation,
        speaker:
          this.selectedExhibitor === "All speakers"
            ? ""
            : this.selectedExhibitor,
      };
      this.getFilteredAgendas(uslov);
      this.getMyAgendaFiltered(uslov);
    },

    resetFilters() {
      this.selectedDay = "All days";
      this.selectedLocation = "All locations";
      this.selectedExhibitor = "All speakers";
      this.selectedTag = [];

      // holds agendas grouped by date & resets filters
      let agendaObj = {};

      for (let i = 0; i < this.allAgendas.length; i++) {
        this.allAgendas[i].displayMoreInfo = false;
        var tAgn = this.allAgendas[i];
        let agnDateFrom = moment(tAgn.agn_from, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD"
        );
        // If this is the first agenda for a day - make new array
        if (agendaObj[agnDateFrom] === undefined) {
          agendaObj[agnDateFrom] = [];
        }
        agendaObj[agnDateFrom].push(tAgn);
      }

      // Make an array of all agenda dates and sort by date - asc
      var allDates = Object.keys(agendaObj);
      allDates.sort((a, b) => {
        let aMom = moment(a);
        let bMom = moment(b);
        if (aMom.isBefore(bMom)) return -1;
        if (aMom.isAfter(bMom)) return 1;
        return 0;
      });

      // Make sure that we have agendas grouped by date
      let sortedAgendas = [];
      for (let i = 0; i < allDates.length; i++) {
        sortedAgendas.push({
          groupDate: allDates[i],
          dayAgendas: agendaObj[allDates[i]],
        });
      }
      this.agendas = sortedAgendas;
     
      // NOVO
         /* Filter for only upcomoing sessions */
        sortedAgendas.forEach((agenda) => {
         agenda.dayAgendas.forEach((dayAgenda) => {
            let dayAgendaFrom = dayAgenda.agn_from;
            let dayAgendaTo = dayAgenda.agn_to;

            let currentTimeFormatted = moment(
              this.currentDateTime,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD HH:mm:ss");

            if (
              dayAgendaTo > currentTimeFormatted
            ) {
               if (
                !this.currentAgendas.filter(
                  (agenda) => agenda.agn_id === dayAgenda.agn_id
                ).length > 0
              ) {
                this.currentAgendas.push(dayAgenda);
              }
            }
         })
        })
           // holds agendas grouped by date
        let currentAgendaObj = {};

        for (let i = 0; i < this.currentAgendas.length; i++) {
          this.currentAgendas[i].displayMoreInfo = false;
          var cAgn = this.currentAgendas[i];
          let agnDateFrom = moment(cAgn.agn_from, "YYYY-MM-DD HH:mm:ss").format(
            "YYYY-MM-DD"
          );
          // If this is the first agenda for a day - make new array
          if (currentAgendaObj[agnDateFrom] === undefined) {
            currentAgendaObj[agnDateFrom] = [];
          }
          currentAgendaObj[agnDateFrom].push(cAgn);
        }

        // Make an array of all agenda dates and sort by date - asc
        var allCurrentDates = Object.keys(currentAgendaObj);
        allCurrentDates.sort((a, b) => {
          let aMom = moment(a);
          let bMom = moment(b);
          if (aMom.isBefore(bMom)) return -1;
          if (aMom.isAfter(bMom)) return 1;
          return 0;
        });

        // Make sure that we have agendas grouped by date
        let sortedCurrentAgendas = [];
        for (let i = 0; i < allCurrentDates.length; i++) {
          sortedCurrentAgendas.push({
            groupDate: allCurrentDates[i],
            dayAgendas: currentAgendaObj[allCurrentDates[i]],
          });
        }
        this.currentAgendas = sortedCurrentAgendas;
        
        this.backupAgendas = this.currentAgendas;
        // NOVO

      // Set active and passed agendas
      sortedAgendas.forEach((agenda) => {
        // dayAgendas, groupDate

        agenda.dayAgendas.forEach((dayAgenda) => {
          let dayAgendaFrom = dayAgenda.agn_from;
          let dayAgendaTo = dayAgenda.agn_to;

          let currentTimeFormatted = moment(
            this.currentDateTime,
            "YYYY-MM-DD HH:mm:ss"
          ).format("YYYY-MM-DD HH:mm:ss");

          if (
            dayAgendaFrom < currentTimeFormatted &&
            dayAgendaTo > currentTimeFormatted
          ) {
            if (
              !this.activeAgendas.filter(
                (agenda) => agenda.agn_id === dayAgenda.agn_id
              ).length > 0
            ) {
              this.activeAgendas.push(dayAgenda);
            }
          } else if (dayAgendaTo < currentTimeFormatted) {
            if (
              !this.passedAgendas.filter(
                (agenda) => agenda.agn_id === dayAgenda.agn_id
              ).length > 0
            ) {
              this.passedAgendas.push(dayAgenda);
            }
          }
        });

        agenda.dayAgendas.sort(this.compare);
      });

      // holds agendas grouped by date
      let passedAgendaObj = {};

      for (let i = 0; i < this.passedAgendas.length; i++) {
        this.passedAgendas[i].displayMoreInfo = false;
        var tAgn2 = this.passedAgendas[i];
        let agnDateFrom = moment(tAgn2.agn_from, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD"
        );
        // If this is the first agenda for a day - make new array
        if (passedAgendaObj[agnDateFrom] === undefined) {
          passedAgendaObj[agnDateFrom] = [];
        }
        passedAgendaObj[agnDateFrom].push(tAgn2);
      }

      // Make an array of all agenda dates and sort by date - asc
      var allDates2 = Object.keys(passedAgendaObj);
      allDates2.sort((a, b) => {
        let aMom = moment(a);
        let bMom = moment(b);
        if (aMom.isBefore(bMom)) return -1;
        if (aMom.isAfter(bMom)) return 1;
        return 0;
      });

      // Make sure that we have agendas grouped by date
      let sortedAgendas2 = [];
      for (let i = 0; i < allDates2.length; i++) {
        sortedAgendas2.push({
          groupDate: allDates2[i],
          dayAgendas: passedAgendaObj[allDates2[i]],
        });
      }
      this.passedAgendasObj = sortedAgendas2;
      this.backupPassedAgendas = sortedAgendas2;

      // holds agendas grouped by date
      let activeAgendaObj = {};

      for (let i = 0; i < this.activeAgendas.length; i++) {
        this.activeAgendas[i].displayMoreInfo = false;
        var tAgn3 = this.activeAgendas[i];
        let agnDateFrom = moment(tAgn3.agn_from, "YYYY-MM-DD HH:mm:ss").format(
          "YYYY-MM-DD"
        );
        // If this is the first agenda for a day - make new array
        if (activeAgendaObj[agnDateFrom] === undefined) {
          activeAgendaObj[agnDateFrom] = [];
        }
        activeAgendaObj[agnDateFrom].push(tAgn3);
      }

      // Make an array of all agenda dates and sort by date - asc
      var allDates3 = Object.keys(activeAgendaObj);
      allDates3.sort((a, b) => {
        let aMom = moment(a);
        let bMom = moment(b);
        if (aMom.isBefore(bMom)) return -1;
        if (aMom.isAfter(bMom)) return 1;
        return 0;
      });

      // Make sure that we have agendas grouped by date
      let sortedAgendas3 = [];
      for (let i = 0; i < allDates3.length; i++) {
        sortedAgendas3.push({
          groupDate: allDates3[i],
          dayAgendas: activeAgendaObj[allDates3[i]],
        });
      }
      this.activeAgendasObj = sortedAgendas3;
      this.backupActiveAgendas = sortedAgendas3;

      this.getMyAgendas();
    },

    handleTimezoneChange(value) {
      let hourValue, mintueValue;
      if (value.includes("+")) {
        let agendaObj = {};
        let hours = value.split(":")[0];
        let minutes = value.split(":")[1];
        hourValue = parseInt(hours);
        mintueValue = parseInt(minutes);
        for (let i = 0; i < this.currentlyShowingAgendas.length; i++) {
          let tempMoment = moment(this.currentlyShowingAgendas[i].agn_from);
          let tempMoment2 = moment(this.currentlyShowingAgendas[i].agn_to);
          tempMoment.add(hourValue, "hours").add(mintueValue, "minutes");
          tempMoment2.add(hourValue, "hours").add(mintueValue, "minutes");

          this.currentlyShowingAgendas[i].agn_from = JSON.stringify(tempMoment);
          this.currentlyShowingAgendas[i].agn_to = JSON.stringify(tempMoment2);
          this.currentlyShowingAgendas[i].displayMoreInfo = false;
          var tAgn = this.currentlyShowingAgendas[i];
          let agnDateFrom = moment(tempMoment, "YYYY-MM-DD HH:mm:ss").format(
            "YYYY-MM-DD"
          );
          // If this is the first agenda for a day - make new array
          if (agendaObj[agnDateFrom] === undefined) {
            agendaObj[agnDateFrom] = [];
          }
          agendaObj[agnDateFrom].push(tAgn);

          // Make an array of all agenda dates and sort by date - asc
          var allDates = Object.keys(agendaObj);
          allDates.sort((a, b) => {
            let aMom = moment(a);
            let bMom = moment(b);
            if (aMom.isBefore(bMom)) return -1;
            if (aMom.isAfter(bMom)) return 1;
            return 0;
          });

          // Make sure that we have agendas grouped by date
          let sortedAgendas = [];
          for (let i = 0; i < allDates.length; i++) {
            sortedAgendas.push({
              groupDate: allDates[i],
              dayAgendas: agendaObj[allDates[i]],
            });
          }
        }
      } else {
        let hours = value.split(":")[0];
        let minutes = value.split(":")[1];
        hourValue = parseInt(hours);
        mintueValue = parseInt(minutes);
        for (let i = 0; i < this.currentlyShowingAgendas.length; i++) {
          let tempMoment = moment(this.currentlyShowingAgendas[i].agn_to);
          tempMoment
            .subtract(hourValue, "hours")
            .subtract(mintueValue, "minutes");
        }
      }
    },

    searchAgendas() {
      if (this.searchText === "") {
        this.agendas = this.backupAgendas;
        this.activeAgendasObj = this.backupActiveAgendas;
        this.passedAgendasObj = this.backupPassedAgendas;
        this.myAgendas = this.backupMyAgendas;
      }
      let searchedAgendas = [];
      let searchActiveAgendas = [];
      let searchPassedAgendas = [];
      let searchMyAgendas = [];

      this.backupAgendas.forEach((agenda) => {
        let newAgenda = agenda.dayAgendas.filter((dayAgenda) =>
          dayAgenda.agn_name
            ? dayAgenda.agn_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.agn_desc
            ? dayAgenda.agn_desc
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_location
            ? dayAgenda.hosted_by_location
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_name
            ? dayAgenda.hosted_by_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.loc_name
            ? dayAgenda.loc_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_firstname
            ? dayAgenda.usr_firstname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_lastname
            ? dayAgenda.usr_lastname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : console.log("no results")
        );

        if (newAgenda.length > 0) {
          searchedAgendas.push({
            dayAgendas: newAgenda,
            groupDate: agenda.groupDate,
          });
        }
      });
      this.currentAgendas = searchedAgendas;

      this.backupActiveAgendas.forEach((agenda) => {
        let newAgenda = agenda.dayAgendas.filter((dayAgenda) =>
          dayAgenda.agn_name
            ? dayAgenda.agn_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.agn_desc
            ? dayAgenda.agn_desc
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_location
            ? dayAgenda.hosted_by_location
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_name
            ? dayAgenda.hosted_by_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.loc_name
            ? dayAgenda.loc_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_firstname
            ? dayAgenda.usr_firstname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_lastname
            ? dayAgenda.usr_lastname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : console.log("no results")
        );

        if (newAgenda.length > 0) {
          searchActiveAgendas.push({
            dayAgendas: newAgenda,
            groupDate: agenda.groupDate,
          });
        }
      });
      this.activeAgendasObj = searchActiveAgendas;

      this.backupPassedAgendas.forEach((agenda) => {
        let newAgenda = agenda.dayAgendas.filter((dayAgenda) =>
          dayAgenda.agn_name
            ? dayAgenda.agn_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.agn_desc
            ? dayAgenda.agn_desc
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_location
            ? dayAgenda.hosted_by_location
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_name
            ? dayAgenda.hosted_by_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.loc_name
            ? dayAgenda.loc_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_firstname
            ? dayAgenda.usr_firstname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_lastname
            ? dayAgenda.usr_lastname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : console.log("no results")
        );

        if (newAgenda.length > 0) {
          searchPassedAgendas.push({
            dayAgendas: newAgenda,
            groupDate: agenda.groupDate,
          });
        }
      });
      console.log("searchPassedAgendas: ", searchPassedAgendas)
      this.passedAgendasObj = searchPassedAgendas;

      this.backupMyAgendas.forEach((agenda) => {
        let newAgenda = agenda.dayAgendas.filter((dayAgenda) =>
          dayAgenda.agn_name
            ? dayAgenda.agn_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.agn_desc
            ? dayAgenda.agn_desc
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_location
            ? dayAgenda.hosted_by_location
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.hosted_by_name
            ? dayAgenda.hosted_by_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.loc_name
            ? dayAgenda.loc_name
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_firstname
            ? dayAgenda.usr_firstname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : dayAgenda.usr_lastname
            ? dayAgenda.usr_lastname
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
            : console.log("no results")
        );

        if (newAgenda.length > 0) {
          searchMyAgendas.push({
            dayAgendas: newAgenda,
            groupDate: agenda.groupDate,
          });
        }
      });
      this.myAgendas = searchMyAgendas;
    },

    showFiltersDrawer() {
      this.filtersDrawerVisible = true;
    },
    onCloseFiltersDrawer() {
      this.filtersDrawerVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");
@import "../../custom-antd.css";

.event-description{
border: 0;
resize: none;
}
.event-description.ant-input[disabled] {
    color: inherit !important;
    background-color:  inherit !important;
    cursor:  inherit !important;
    opacity: 1;
    margin-bottom:50px;
}

.side-bar-wrap {
  display: none !important;
}

.meeting-card {
  margin-bottom: 0 !important;
  margin-top: -1px;
}

.meeting-card.active {
  border-right: 5px solid #4ba673;
}

.purple-meeting-btn {
  background-color: #652d90;
  font-size: 16px;
  line-height: 24px;
  color: white;
  border-color: #652d90;
}

.empty-slot {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #001529;
  margin: 0;
}

.vertical-middle {
  justify-content: center;
  align-items: center;
  display: inline-flex;
  height: 100%;
}

.vertical-middle.speaker-info {
  flex-direction: column;
  align-items: unset;
}

.vertical-middle.speaker-info .btn {
  padding: unset;
}

.vertical-middle.speaker-info .green-btn {
  max-width: 90px;
}

.vertical-middle.speaker-info .yellow-btn {
  max-width: 120px;
}

.meeting-time {
  text-align: right;
  align-items: unset;
}

.time {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 36px;
  color: #333333;
}

.time sub {
  font-size: 12px;
  line-height: 20px;
}

.date {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: #333333;
}

.time,
.date {
  margin: 0;
}

.vertical-line {
  margin-left: auto;
  margin-right: auto;
  width: 1px;
  height: 80%;
  background-color: #e5e5e5;
  position: relative;
  top: 10%;
}

.meeting-speaker-name {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

.meeting-speaker-role {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin-bottom: 8px;
}

.page-title {
  color: #001529;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  text-align: left;
}

.download-btn {
  background: #fff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  color: #2c396a;
  font-size: 16px;
  line-height: 40px;
  font-family: "Roboto", sans-serif;
  float: right;
  height: 40px;
  margin-right: 10px;
}

.download-btn .fa-download {
  margin-left: 14px;
  line-height: 24px;
  font-size: 16px;
  vertical-align: 0;
}

.search-btn {
  background: #fff;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  color: #2c396a;
  font-size: 16px;
  line-height: 24px;
  font-family: "Roboto", sans-serif;
  float: right;
  height: 42px;
  width: 200px;
}

.filter-headline {
  display: inline-block;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #001529;
  font-family: "Roboto", sans-serif;
  margin-bottom: 0;
}

.filter-btn .fa-check {
  vertical-align: -0.1em;
  margin-left: 5px;
}

input:focus-visible {
  outline: none !important;
}

.ant-card {
  margin-bottom: 16px;
}

.ant-card-head {
  border: 0 !important;
}

.ant-card-body {
  padding: 0 !important;
}

.ant-tabs-tab {
  margin-bottom: 10px !important;
}

.agendaTabs .ant-tabs-tab-active {
  color: #374785 !important;
}

.agenda-day {
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  text-transform:capitalize;
}

.gray-card.dimmed .space-align-block {
  background: #cbcbe4;
}

.gray-card .space-align-block {
  background: #cbcbe4;
}

.green-card .space-align-block {
  background: #4ba673;
}

.blue-card .space-align-block {
  background: #374785;
}

.yellow-card .space-align-block {
  background: #f7bb58;
}

.space-align-container {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  background: #f1f1f8;
  border-radius: 2px;
}

.space-align-block {
  text-align: center;
  display: inline-block;
  font-size: 32px;
  width: 92px;
  height: 92px;
  padding: 30px;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
}

.white-box {
  background: white;
  color: #001529;
  text-align: right;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 36px;
}

.white-box .time-from {
  margin: 0;
}

.white-box sub {
  bottom: 0;
}

.white-box sub,
.white-box .time-to {
  font-size: 16px;
  margin: 0;
}

.passed .white-box {
  color: #cbcbe4;
}

.live-event {
  display: none;
}

.live .live-event {
  padding: 1px 20px;
  background: #d23214;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  position: relative;
  top: -8px;
  color: #fff;
  display: inline-block;
}

.card-title {
  display: block;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  max-width: 50%;
}

.card-content-container {
  color: inherit;
  margin-top: -24px;
}

.card-time {
  width: 145px;
}

.card-buttons {
  position: relative;
  bottom: 16px;
  top: 30px;
  width: 100%;
}

.card-button {
  padding: 2px 10px;
  text-align: center;
  display: inline-block;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  border-radius: 2px;
  font-family: "Roboto", sans-serif;
  background-color: rgba(255, 255, 255, 0.75);
}

.card-button.lang {
  margin-left: 20px;
}

.card-button.join {
  text-transform: uppercase;
  float: right;
  background: #fff;
  position: relative;
  display: none;
}

.live .card-button.join {
  display: inline-block;
}

.card-lang-link {
  position: absolute;
  bottom: 16px;
  left: 220px;
}

.card-lang {
  height: 36px;
  width: 36px;
  border-radius: 2px;
}

.card-agenda {
  display: block;
  color: inherit;
  font-size: 14px;
  line-height: 24px;
  font-family: "Roboto", sans-serif;
  text-align: right;
  opacity: 1;
}

.ant-card-grid {
  box-shadow: none;
  height: 124px;
  padding: 16px;
  padding-left: 0;
}

.passed .card-description,
.passed .card-button {
  color: #cbcbe4 !important;
}

.passed .card-button:hover {
  cursor: not-allowed;
}

.passed .card-agenda,
.live .card-agenda {
  opacity: 0;
}

.passed .card-agenda:hover,
.live .card-agenda:hover {
  cursor: default;
}

.gray-card .card-description {
  background: #ebebf5;
}

.card-description {
  padding: 16px;
  border-radius: 2px;
  color: white;
  width: calc(100% - 145px);
  float: right;
}

.green-card .card-description {
  background: #5ecf90;
}

.purple-card .card-description {
  background: #b4b4dc;
}

.blue-card .card-description {
  background: #5f6c9d;
}

.yellow-card .card-description {
  background: #f3bb63;
}

.turquise-card .card-description {
  background: #48a7c7;
}

.green-card.active {
  border-right: 5px solid #4ba673;
}

.purple-card.active {
  border-right: 5px solid #a2a2c6;
}

.agenda-star {
  font-size: 16px;
  vertical-align: -0.25em;
}

.gray-card.dimmed .card-button {
  color: #2c396a;
}

.gray-card .card-button {
  color: #2c396a;
}

.purple-card .card-button {
  color: #a2a2c6;
}

.green-card .card-button {
  color: #4ba673;
}

.blue-card .card-button {
  color: #323f75;
}

.yellow-card .card-button {
  color: #d89936;
}

.turquise-card .card-button {
  color: #4196b3;
}

.gray {
  color: #7c7c7c;
  font-weight: 700;
  font-size: 18px;
  line-height: 40px;
  display: inline;
  font-family: "Roboto", sans-serif;
}

.align-right {
  float: right;
}

.session-heading {
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
  font-family: "Roboto", sans-serif;
  margin-top: 10px;
  margin-bottom: 0;
  color: #001529;
}

.session-type {
  font-size: 16px;
  line-height: 28px;
  text-transform: uppercase;
  color: #2c396a;
  font-family: "Roboto", sans-serif;
  margin-bottom: 16px;
  margin-top: 16px;
}

.session-description-heading {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #b7b7cd;
  text-transform: uppercase;
  font-family: "Roboto", sans-serif;
}

.session-description {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #001529;
  font-family: "Roboto", sans-serif;
}

.time-information {
  margin-bottom: 24px;
}

.time-information .session-description {
  margin-bottom: 0;
}

.green-btn {
  background: #5ecf90;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  padding: 8px 44px;
  height: 40px;
  display: block;
  font-family: "Roboto", sans-serif;
}

.yellow-btn {
  background: #f3bb63;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  padding: 8px 44px;
  height: 40px;
  display: block;
  font-family: "Roboto", sans-serif;
}

.sesssion-additional-info-heading {
  font-size: 16px;
  line-height: 22px;
  color: #001529;
  text-transform: uppercase;
  padding-top: 24px;
  font-family: "Roboto", sans-serif;
}

.sesssion-additional-info {
  display: block;
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  color: #001529;
  font-family: "Roboto", sans-serif;
}

.sesssion-additional-info.strong {
  font-size: 16px;
}

.breakout-heading {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  color: #001529;
  margin-bottom: 0;
}

.breakout-speaker {
  margin-bottom: 30px;
}

.green-btn.breakout {
  margin-bottom: 30px;
}

.fa-users {
  vertical-align: -0.25em !important;
}

.pl-14 {
  padding-left: 14px;
}

.strong {
  font-weight: 700;
}

.gray-hr {
  color: #e5e5e5;
  border-top: 0;
}

.svg-inline--fa {
  vertical-align: 0.125em;
}

.fa-star {
  vertical-align: -0.125em;
}

.add-to-agenda-btn {
  margin-left: 8px;
  background: #fff;
  height: 40px;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  color: #2c396a;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.add-to-calendar-btn {
  border-radius: 2px;
  padding: 0px 16px;
  width: 190px;
  color: #262626;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.add-to-calendar-btn .ant-select-arrow {
  color: #262626;
}

.close-preview {
  position:relative;
  font-size: 14px;
  color: #2c396a;
  float: right;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  z-index: 999;
}

.gray-dropdown {
  background: #f1f1f8;
  border-radius: 2px;
  padding: 0px 16px;
  color: #001529;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.gray-dropdown .ant-select-arrow {
  color: #7c7c7c;
}

.white-dropdown {
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 2px;
  margin-right: 16px;
  color: #262626;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 22px;
  height: 40px;
}

.filter-row {
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 16px;
}

.filter-btn {
  padding: 1px 0;
  border-radius: 2px;
  border: 0;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 22px;
  top: 10px;
  width: 275px;
  height: 32px;
}

.filter-btn-no {
  background: #f1f1f8;
  border-radius: 2px;
  color: #001529;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 22px;
  padding: 0 8px;
  border: 0;
  width: 32px;
  height: 32px;
}

.filter-wrap {
  display: block;
  width: auto;
  margin-left: auto;
  margin-bottom: -40px;
  margin-top: 15px;
  z-index: 3;
}

h2 .agenda-star {
  font-size: 32px;
  margin-left: 10px;
}

.session-image {
  border-radius: 2px;
  width: 100%;
  margin-bottom: 16px;
}

.active-sessions-tab {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff0000;
  display: inline-block;
  margin-right: 5px;
}

.heading-wrap h1,
.heading-wrap h2,
.heading-wrap h3 {
  margin: 0.5% 0;
}
.heading-wrap h2 {
  font-weight: 100;
}
.heading-wrap {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 10px 0;
}

.ics-wrap {
  display: flex;
  justify-content: flex-end;
  width: 80%;
  margin-bottom: 10px;
  img {
    width: 35px;
    height: 35px;
  }
  a {
    display: flex;
    align-items: center;
    padding: 0 10px;
    background-color: #7397ce;
    border: none;
    outline: none;
    font-weight: 700;
    font-size: 17px;
    cursor: pointer;
    color: white;
    border-radius: 15px;
  }
}
.agenda-page-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}
.message {
  text-align: center;
  margin-top: 270px;
}
.arrow-wrap {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: sticky;
  bottom: 40px;
  opacity: 0.8;
}
</style>
